<template>
    <div v-if="page_loading">
        <loading :page_loading="page_loading" />
    </div>
    <div v-else>
      <loading :loading="loading" />

      <!-- แสดงภาพ -->
      <v-dialog v-model="ShowPhoto" max-width="500">
        <v-card class="ma-0">
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" class="text-center">
                <img class="hidden-md-and-up" :src="ShowPhotoLink" width="300">
                <img class="hidden-sm-and-down" :src="ShowPhotoLink" width="450">
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-btn text color="#1976d2" @click="Opentap(ShowPhotoLink)">{{use_language.newtab}}</v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="#1976d2" @click="ShowPhoto = false">{{use_language.close}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card elevation="1" class="v-card-bottom-30 hidden-xs-only">
        <v-card-title style="height: 60px;">
          <h4>{{use_language.setting}}</h4> <v-icon>mdi-chevron-right</v-icon><span class="font-weight-regular body-1">{{use_language.shop}}</span>
          <v-spacer/>
        </v-card-title>
      </v-card>

      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="20" color="teal darken-3">fa-address-card</v-icon> <span class="ml-3">{{use_language.shop_info}}</span>
          <v-spacer/>
          <v-btn :elevation="1" color="primary" class="pa-2" @click="shopDisibled = !shopDisibled">
            <v-icon size="16" class="pr-1">fa-edit</v-icon>
            {{use_language.edit}}
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text >
          <v-form ref="updateShopForm" lazy-validation>
            <v-row row >
              <v-col cols="12" md="6" class="pb-2 pt-0 px-0">
                <v-row row >
                  <v-col  cols="12" md="4" class="py-0">
                    <h4>{{use_language.shop_name}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="8" class="py-0">
                    <v-text-field
                      :value="ShopAddress.Name"
                      @change="value => ShopAddress.Name = value"
                      autocomplete="off"
                      ref="refShopName"
                      :rules="[ v => !!v || use_language.please_specify, ]"
                      outlined
                      hide-details
                      dense
                      :disabled="shopDisibled"
                      v-if="shopDisibled== false"
                    ></v-text-field>
                    <span v-else>{{ ShopAddress.Name }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="6" class="pb-2 pt-0 px-0">
                <v-row row >
                  <v-col  cols="12" md="4" class="py-0">
                    <h4>{{use_language.email}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="8" class="py-0">
                    <v-text-field
                      :value="ShopAddress.Email"
                      @change="value => ShopAddress.Email = value"
                      autocomplete="off"
                      ref="refShopEmail"
                      :rules="[ v => !!v || use_language.please_specify, ]"
                      outlined
                      hide-details
                      dense
                      :disabled="shopDisibled"
                      v-if="shopDisibled== false"
                    ></v-text-field>
                    <span v-else>{{ ShopAddress.Email }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-2 pt-0 px-0">
                <v-row row >
                  <v-col  cols="12" md="2" class="py-0">
                    <h4>{{use_language.create_order}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="10" class="py-0">
                    <span v-if="shopDisibled">{{ OrderActiveLessthanzero }}</span>
                    <v-radio-group v-else row v-model="OrderActiveLessthanzero">
                      <v-radio v-for="i in OrderActiveLessthanzeroItem" color="info" v-bind:key="i['value']" :label="i['label']" :value="i['value']"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
            </v-row>
            <v-row row v-if="shopDisibled == false">
              <v-col  cols="12" md="12" class="pb-2 pt-0 px-0">
                <v-row row >
                  <v-col  cols="12" md="12" align="left" class="py-0">
                    <v-btn dark color="primary" @click="UpdateShopAddress()" class="mr-1"><v-icon left >mdi-content-save</v-icon>  {{use_language.record}}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>

      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
        <v-icon size="20" color="primary darken-3">fa-map-marked-alt</v-icon><span class="ml-3">  {{use_language.tax_invoice_address}}</span>
        <v-spacer/>
        <v-btn @click="addShopAddressInvoice(), ShopAddressType= 'ADD'" dark color="primary"><v-icon left>mdi-plus</v-icon>   {{use_language.add_address}}</v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row>
            <v-col cols="12" md="12">
              <div style="max-height: 500px;" class="overflow-y-auto">
                <v-data-table :headers="headersShopAddressInvoice" :items="ShopAddressInvoiceData" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">
                  <template v-slot:item.shopLogo="{ item }">
                    <a v-if="item.shopLogo!=null" @click="OpenPhoto(item.shopLogo)"><img :src="item.shopLogo" width="60" class="mt-1" /></a>
                  </template>
                  <template v-slot:item.fullAddress="{ item }">
                    {{ item.fullAddress }}
                    <v-chip v-if="item.isDefault" class="chip-set-13" color="primary" dark>  {{use_language.default}}  </v-chip>
                  </template>
                  <template v-slot:item.edit="{ item }">
                    <a @click="getShopAddressInvoiceForEdit(item), ShopAddressType = 'EDIT' "><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a>
                  </template>
                  <template v-slot:item.delete="{ item }">
                    <a v-if="!item.isDefault" @click="deleteShopAddressInvoice(item.id)"><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a>
                    <v-icon v-else size="16">fa-trash-alt</v-icon>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="20" color="warning darken-3">fa-map-marked-alt</v-icon><span class="ml-3"> {{use_language.delivery_address}} </span>
          <v-spacer/>
          <v-btn @click="ShopAddressAction(null, 'ADD') " dark color="primary"><v-icon left>mdi-plus</v-icon>   {{use_language.add_address}} </v-btn>
        </v-card-title>
        <v-divider/>

        <v-card-text>
          <v-row row>
            <v-col  cols="12" md="12">
              <div style="max-height: 500px;" class="overflow-y-auto">
                <v-data-table :headers="headers1" :items="DataShopAddressManage" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">
                  <template v-slot:item.fullAddress="{ item }">
                    {{ item.fullAddress }}
                    <v-chip v-if="item.isDefault" class="chip-set-13" color="primary" dark>  {{use_language.default}} </v-chip>
                  </template>
                  <template v-slot:item.edit="{ item }">
                    <a @click="ShopAddressAction(item, 'EDIT')"><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a>
                  </template>
                  <template v-slot:item.delete="{ item }">
                    <a v-if="!item.isDefault" @click="ShopAddressAction(item, 'DELETE')"><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a>
                    <v-icon v-else size="16">fa-trash-alt</v-icon>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="20" color="orange darken-3">fa-money-check-alt</v-icon><span class="ml-3">{{use_language.bank_account}}</span>
          <v-spacer/>
          <v-btn @click="BankAcountAction(null, 'ADD')" dark color="primary"><v-icon left>mdi-plus</v-icon> {{use_language.default}} </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row>
            <v-col cols="12" md="12">
              <div style="max-height: 500px;" class="overflow-y-auto">
                <v-data-table :headers="headersBankAcount" :items="ShopBankAcountData" class="elevation-0 packhai-border-table" hide-default-footer :items-per-page="10000">

                  <template v-slot:item.FullBankAcount="{ item }">
                    <a v-if="item.logo!=null" @click="OpenPhoto(item.logo)"><v-avatar size="25px" class="mr-2"><img :src="item.logo"/></v-avatar></a>
                    {{ item.bankName+' '+item.accountNumber+' '+item.accountName }}
                    <v-chip v-if="item.isDefault" class="chip-set-13" color="primary" dark> {{use_language.default}} </v-chip>
                  </template>
                  <template v-slot:item.isActive="{ item }">
                    <v-row>
                      <v-col cols="12" class="text-left">
                        <span v-if="item.isActive"><v-icon size="10" color="success">mdi-checkbox-blank-circle</v-icon> {{use_language.enable}}</span>
                        <span v-else><v-icon size="10" color="danger">mdi-checkbox-blank-circle</v-icon> {{use_language.disable}}</span>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:item.edit="{ item }">
                    <a @click="BankAcountAction(item, 'EDIT')"><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a>
                  </template>
                  <template v-slot:item.delete="{ item }">
                    <a v-if="!item.isDefault" @click="BankAcountAction(item, 'DELETE')"><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a>
                    <v-icon v-else size="16">fa-trash-alt</v-icon>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="20" color="yellow darken-3">fa-cog</v-icon><span class="ml-3">{{use_language.open_order_by_customer_transfer}}</span>
          <v-spacer/>
          <v-btn :elevation="1" color="primary" class="pa-2" @click="addOrderModeDisibled = !addOrderModeDisibled">
            <v-icon size="16" class="pr-1">fa-edit</v-icon>
            {{use_language.edit}}
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row >
            <v-col  cols="12" md="12">
              <v-radio-group
                v-model="AddOrderMode"
                column
                :disabled="addOrderModeDisibled"
              >
                <v-radio
                  :label="use_language.open_order_wati_pack"
                  value="1"
                ></v-radio>
                <v-radio
                  :label="use_language.open_order_wati_balance"
                  value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row row v-if="addOrderModeDisibled == false">
            <v-col  cols="12" md="12" class="py-0 px-0">
              <v-row row >
                <v-col  cols="12" md="12" align="left" class="py-0">
                  <v-btn dark color="primary" @click="UpdateAddOrderModeDisibled()" class="mr-1"><v-icon left >mdi-content-save</v-icon> {{use_language.record}}</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- create customer COD order setting -->
      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="20" color="red darken-3">fa-cog</v-icon><span class="ml-3">{{use_language.open_order_by_customer_cod}}</span>
          <v-spacer/>
          <v-btn :elevation="1" color="primary" class="pa-2" @click="addOrderModeDisibledCod = !addOrderModeDisibledCod">
            <v-icon size="16" class="pr-1">fa-edit</v-icon>
            {{use_language.edit}}
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row >
            <v-col  cols="12" md="12">
              <v-radio-group
                v-model="AddOrderModeCod"
                column
                :disabled="addOrderModeDisibledCod"
              >
                <v-radio
                  :label="use_language.open_order_wati_pack"
                  value="1"
                ></v-radio>
                <v-radio
                  :label="use_language.open_order_wati_balance"
                  value="2"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row row v-if="addOrderModeDisibledCod == false">
            <v-col  cols="12" md="12" class="py-0 px-0">
              <v-row row >
                <v-col  cols="12" md="12" align="left" class="py-0">
                  <v-btn dark color="primary" @click="UpdateAddOrderModeDisibledCod()" class="mr-1"><v-icon left >mdi-content-save</v-icon> {{use_language.record}}</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="24" color="success darken-3">mdi-file-cog-outline </v-icon>
          <span class="ml-3">{{use_language.set_tax_type_by_open_order}}</span>
          <v-spacer/>
          <v-btn :elevation="1" color="primary" class="pa-2" @click="VatTypeDisibled = !VatTypeDisibled">
            <v-icon size="16" class="pr-1">fa-edit</v-icon>
            {{use_language.edit}}
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row >
            <v-col  cols="12" md="12">
              <v-radio-group
                v-model="VatType"
                column
                :disabled="VatTypeDisibled"
              >
                <v-radio
                  :label="use_language.vat_type_no_vat"
                  value="1"
                ></v-radio>
                <v-radio
                  :label="use_language.vat_type_included"
                  value="2"
                ></v-radio>
                <v-radio
                  :label="use_language.vat_type_excluded"
                  value="3"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row row v-if="VatTypeDisibled == false">
            <v-col  cols="12" md="12" class="py-0 px-0">
              <v-row row >
                <v-col  cols="12" md="12" align="left" class="py-0">
                  <v-btn dark color="primary" @click="UpdateVatType()" class="mr-1"><v-icon left >mdi-content-save</v-icon> {{use_language.record}}</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="24" color="red darken-3">fa-file-invoice-dollar </v-icon>
          <span class="ml-3">{{use_language.tax_type}}</span>
          <v-spacer/>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row >
            <v-col  cols="12" md="12">
              <v-radio-group
                v-model="AutoInvoiceType"
                column
                :disabled="true"
                v-if="AutoInvoiceType != null"
              >
                <v-radio
                  :label="use_language.auto_invoice_manual"
                  :value="1"
                ></v-radio>
                <v-radio
                  :label="use_language.auto_invoice_daily_no_bill"
                  :value="2"
                ></v-radio>
                <v-radio
                  :label="use_language.auto_invoice_daily_bill"
                  :value="3"
                ></v-radio>
              </v-radio-group>
              <span v-else>{{use_language.unspecified}}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card> -->

      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="24" color="info darken-3">mdi-store </v-icon>
          <span class="ml-3">{{use_language.sales_channel}}</span>
          <v-spacer/>
          <v-btn dark color="primary" @click="ChannelSourceAction(null,'ADD')"><v-icon left>mdi-plus</v-icon> {{use_language.add_channel}} </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row>
            <v-col cols="12" md="12">
              <div style="max-height: 500px;" class="overflow-y-auto">
                <v-data-table
                  :headers="headerschannelsource"
                  :items="Datatable_ChannelSource"
                  class="elevation-0 packhai-border-table"
                  hide-default-footer
                  :items-per-page="10000">
                  <template v-slot:item.logoPic="{ item }">
                    <a v-if="item.logoPic!=null" @click="OpenPhoto(item.logoPic)"><img :src="item.logoPic" width="60" class="mt-1" /></a>
                  </template>
                  <template v-slot:item.channelName="{ item }" >
                    <span >{{ item.channelName }}</span>
                  </template>
                  <template v-slot:item.created="{ item }">
                    {{item.created}}
                  </template>
                  <template v-slot:item.edit="{ item }">
                    <a @click="ChannelSourceAction(item, 'UPDATE')"><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a>
                  </template>
                  <template v-slot:item.delete="{ item }">
                    <a @click="ChannelSourceAction(item, 'DELETE')"><v-icon size="16" color="red darken-3">fa-trash-alt</v-icon></a>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- prfix/suffix setting -->
      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="24" color="dark darken-3">mdi-file-document </v-icon>
          <span class="ml-3">{{use_language.bill_abbreviation}}</span>
          <v-spacer/>
          <v-btn @click="openDialogAbbeviation(false)" v-if="abbreviationList.length == 0" dark color="primary" >
            <v-icon left>mdi-plus</v-icon> {{use_language.add_abbreviation}}
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row>
            <v-col cols="12" md="12">
              <div style="max-height: 500px;" class="overflow-y-auto">
                <v-data-table
                  :headers="headersAbbreviation"
                  :items="abbreviationList"
                  class="elevation-0 packhai-border-table"
                  hide-default-footer
                  :items-per-page="10000"
                >
                  <template v-slot:item.edit="{ item }">
                    <a @click="openDialogAbbeviation(true, item)"><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- stamped setting -->
      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="24" color="info darken-3">mdi-stamper</v-icon>
          <span class="ml-3">{{use_language.stamp}}</span>
          <v-spacer/>
          <v-btn @click="openDialogStamped(false)" v-if="stampedList.length == 0" dark color="primary" >
            <v-icon left>mdi-plus</v-icon> {{use_language.add_stamp}}
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row>
            <v-col cols="12" md="12">
              <div style="max-height: 500px;" class="overflow-y-auto">
                <v-data-table
                  :headers="headersStamped"
                  :items="stampedList"
                  class="elevation-0 packhai-border-table"
                  hide-default-footer
                  :items-per-page="10000"
                >
                  <template v-slot:item.signature="{ item }">
                    <a v-if="item.signature != null" @click="OpenPhoto(item.signature)">
                      <img :src="item.signature" width="80" class="mt-1" />
                    </a>
                  </template>
                  <template v-slot:item.seal="{ item }">
                    <a v-if="item.seal != null" @click="OpenPhoto(item.seal)">
                      <img :src="item.seal" width="80" class="mt-1" />
                    </a>
                  </template>
                  <template v-slot:item.edit="{ item }">
                    <a @click="openDialogStamped(true, item)"><v-icon size="16" color="orange darken-3">fa-edit</v-icon></a>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- header excel setting -->
      <v-card elevation="1" class="v-card-bottom-30" id="excelHeaderCard" ref="excelHeaderCard">
        <v-card-title>
          <v-icon size="24" color="success darken-3">fa-file-excel</v-icon>
          <span class="ml-3">Excel Header</span>
          <v-spacer/>
          <v-btn @click="openDialogExcelHeader(true)" dark color="primary" >
            <v-icon left>fa-cog</v-icon> {{use_language.setting_excel_header}}
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row row>
            <v-col cols="12" md="12">
              <div style="max-height: 500px;" class="overflow-y-auto">
                <v-data-table
                  :headers="headersExcelHeader"
                  :items="ExcelHeaderList"
                  class="elevation-0 packhai-border-table"
                  hide-default-footer
                  :items-per-page="10000"
                >
                  <template v-slot:item.no="{ item }">
                    {{ExcelHeaderList.findIndex(x => x.id == item.id) + 1}}
                  </template>
                  <template v-slot:item.edit="{ item }">
                    <a @click="openDialogExcelHeader(false, item)">
                      <v-icon size="16" color="orange darken-3">fa-edit</v-icon>
                    </a>
                  </template>
                  <template v-slot:item.delete="{ item }">
                    <a v-if="item.isDefault == false" @click="btnDeleteHeaderExcel(item)">
                      <v-icon size="16" color="red darken-3">fa-trash</v-icon>
                    </a>
                  </template>
                  <template v-slot:item.copy="{ item }">
                    <a @click="btnCopyHeaderExcel(item)">
                      <v-icon size="16" color="green darken-3">fa-copy</v-icon>
                    </a>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- เสียงแจ้งเตือน (Alert Sound) -->
      <v-card elevation="1" class="v-card-bottom-30">
        <v-card-title>
          <v-icon size="22" color="blue darken-3">mdi-volume-high</v-icon>
          <span class="ml-3">{{use_language.alert_sound}}</span>
          <v-spacer/>
          <v-btn dark color="primary" @click="btnSaveAlertSound">
            <v-icon left>mdi-content-save</v-icon> {{ use_language.save }}
          </v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-row v-for="s in alertSoundRows" :key="s.key" class="align-center">
            <v-col cols="12" md="3"><b>{{ s.label }}</b></v-col>
            <v-col cols="12" md="5">
              <v-text-field v-model="alertSound[s.key]" :placeholder="use_language.upload_file_or_paste_url" outlined dense hide-details clearable />
            </v-col>
            <v-col cols="12" md="4">
              <input type="file" accept="audio/*" style="display:none" :ref="'soundFile_'+s.key" @change="onSoundFileChange($event, s.key)" />
              <v-btn small outlined color="blue darken-3" class="mr-2" :loading="soundUploading===s.key" @click="triggerSoundUpload(s.key)">
                <v-icon left small>mdi-upload</v-icon> {{use_language.upload}}
              </v-btn>
              <v-btn small outlined color="green darken-2" :disabled="!alertSound[s.key]" @click="playAlertSound(s.key)">
                <v-icon left small>mdi-play</v-icon> {{use_language.test}}
              </v-btn>
            </v-col>
          </v-row>
          <div class="mt-2 grey--text" style="font-size:12px">{{use_language.alert_sound_empty_note}}</div>
          <div class="grey--text" style="font-size:12px">{{use_language.alert_sound_relogin_note}}</div>
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialog_Abbreviation" :fullscreen="isFullscreen"  scrollable max-width="60%" persistent >
        <v-card>
          <v-card-title >
            <span>{{use_language.add_abbreviation}}</span>
            <v-spacer></v-spacer>
            <v-btn icon  @click="dialog_Abbreviation = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <div> 
              <v-row class="pt-3">
                <v-col cols="4" class="py-0 pt-1">
                  <h3 class="fn-14"> {{use_language.quotation}} : </h3>
                </v-col>
                <v-col cols="8" class="py-0 pt-1">
                  <v-text-field
                    v-model="updateAbbreviation.quotationPrefix"
                    autocomplete="off"
                    outlined
                    hide-details
                    dense
                  />
                </v-col>
              </v-row>
              <v-row class="pt-3">
                <v-col cols="4" class="py-0 pt-1">
                  <h3 class="fn-14"> {{use_language.tax_invoice_sale_order}} : </h3>
                </v-col>
                <v-col cols="8" class="py-0 pt-1">
                  <v-text-field
                    v-model="updateAbbreviation.invoicePrefix"
                    autocomplete="off"
                    outlined
                    hide-details
                    dense
                  />
                </v-col>
              </v-row>
              <v-row class="pt-3">
                <v-col cols="4" class="py-0 pt-1">
                  <h3 class="fn-14"> {{use_language.receipt}} : </h3>
                </v-col>
                <v-col cols="8" class="py-0 pt-1">
                  <v-text-field
                    v-model="updateAbbreviation.receiptPrefix"
                    autocomplete="off"
                    outlined
                    hide-details
                    dense
                  />
                </v-col>
              </v-row>
              <v-row class="pt-3">
                <v-col cols="4" class="py-0 pt-1">
                  <h3 class="fn-14"> {{use_language.menu_delivery_note}} : </h3>
                </v-col>
                <v-col cols="8" class="py-0 pt-1">
                  <v-text-field
                    v-model="updateAbbreviation.deliveryPrefix"
                    autocomplete="off"
                    outlined
                    hide-details
                    dense
                  />
                </v-col>
              </v-row>
          
            </div>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn @click="btnUpdateAbbreviation" dark color="primary" class="mr-1">
                  <v-icon left >mdi-content-save</v-icon> {{ use_language.save }}
                </v-btn>
              </v-col>
            </v-row>
          
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_Stamped" :fullscreen="isFullscreen"  scrollable max-width="50%" persistent >
        <v-card>
          <v-card-title >
            <span v-if="updateStamped.isEdit == false" >{{use_language.add_stamp}}</span>
            <span v-else-if="updateStamped.isEdit == true" >{{use_language.edit_stamp}}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialogStamped()"><v-icon color="danger">mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <div>
              <v-row>
                <v-col cols="3" class="py-1">
                  <h3 class="fn-14"> {{use_language.signature}} : </h3>
                </v-col>
                <v-col cols="8" class="py-1">
                  <div v-if="updateStamped.signature != null">
                    <v-avatar
                      class="sshoverpicture" size="90" tile >
                      <img :src="updateStamped.signature" />
                    </v-avatar>
                    <a class="pl-3" @click="updateStamped.signature = null">
                      <v-icon size="16" color="red darken-3">fa-trash</v-icon>
                    </a>
                  </div>
                  <v-file-input
                    v-else
                    v-model="fileSignature"
                    :label="use_language.select_image"
                    append-icon="mdi-camera"
                  ></v-file-input>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" class="py-1">
                  <h3 class="fn-14"> {{use_language.stamp}} : </h3>
                </v-col>
                <v-col cols="8" class="py-1">
                  <div v-if="updateStamped.seal != null">
                    <v-avatar
                      class="sshoverpicture" size="90" tile >
                      <img :src="updateStamped.seal" />
                    </v-avatar>
                    <a class="pl-3" @click="updateStamped.seal = null">
                      <v-icon size="16" color="red darken-3">fa-trash</v-icon>
                    </a>
                  </div>
                  <v-file-input
                    v-else
                    v-model="fileSeal"
                    :label="use_language.select_image"
                    append-icon="mdi-camera"
                  ></v-file-input>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="text-right">
                <v-btn @click="btnUpdateStamped()" dark color="primary" class="mr-1">
                  <v-icon left >mdi-content-save</v-icon> {{ use_language.save }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_ExpressManage" :fullscreen="isFullscreen"  scrollable max-width="45%" persistent >
        <v-card>
          <v-card-title >
            <span>{{use_language.setting_express}}</span>
            <v-spacer></v-spacer>
            <v-btn icon  @click="dialog_ExpressManage = false, express_data = null"><v-icon color="danger">mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <strong>{{ use_language.set_as_default }} :</strong>
              </v-col>
              <v-col cols="12" md="9">
                <v-checkbox
                  v-model="checkbox1"
                  readonly
              ></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn color="primary"  @click="set_default_express(express_data)">{{ use_language.save }}</v-btn>
              </v-col>
            </v-row>


          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_ShopAddressManage" :fullscreen="isFullscreen"  scrollable max-width="45%" persistent >
        <v-card>
          <v-card-title >
            <span v-if="ShopAddressType == 'EDIT'">{{use_language.edit_address}}</span>
            <span v-else-if="ShopAddressType == 'ADD'">{{use_language.add_address}}</span>
            <v-spacer></v-spacer>
            <v-btn icon  @click="dialog_ShopAddressManage = false, IsReadonly = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                  <h4> {{use_language.name_person_juristic}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="ShopAddressManage.Name"
                      @change="value => ShopAddressManage.Name = value"
                      autocomplete="off"
                      ref="refShopAddressManageName"
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4>{{use_language.tel}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="ShopAddressManage.Phone"
                      @change="value => ShopAddressManage.Phone = value"
                      autocomplete="off"
                      ref="refShopAddressManagePhone"
                      maxlength="10"
                      outlined
                      hide-details
                      @keypress="isNumberWNoDot($event)"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                  <h4>  {{use_language.address}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="ShopAddressManage.TextAddress"
                      @change="value => ShopAddressManage.TextAddress = value"
                      autocomplete="off"
                      ref="refShopAddressManageTextAddress"
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4>{{use_language.zipcode}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-autocomplete
                      v-model="ShopAddressManage.Address"
                      ref="refShopAddressManageAddress"
                      placeholder="รหัสไปรษณีย์ / จังหวัด / (เขต/อำเภอ) / (แขวง/ตำบล)"
                      :items="postcode_mapping"
                      :item-text="item => item.postcode + ' ' + item.province + ' ' + item.district + ' ' + item.subDistrict"
                      outlined
                      required
                      return-object
                      hide-details
                      dense

                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4> {{use_language.set_default}}:</h4>
                  </v-col>
                  <v-col  cols="12" md="1" class="py-0">
                    <v-checkbox
                      :readonly="IsReadonly"
                      v-model="ShopAddressManage.IsDefault"
                    ></v-checkbox>
                  </v-col>
                  <v-col  cols="12" md="8">
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col  cols="12" md="12" class="py-0 px-0">
                <v-row row >
                  <v-col  cols="12" md="12" align="left">
                    <v-btn dark color="primary" @click="ShopAddressActionConfirm()" class="mr-1"><v-icon left >mdi-content-save</v-icon> {{use_language.record}}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_ShopAddressInvoice" :fullscreen="isFullscreen"  scrollable max-width="45%" persistent >
        <v-card>
          <v-card-title >
            <span v-if="ShopAddressType == 'EDIT'" >{{use_language.edit_tax_invoice_address}}</span>
            <span v-else-if="ShopAddressType == 'ADD'" >{{use_language.add_tax_invoice_address}}</span>
            <v-spacer></v-spacer>
            <v-btn icon  @click="dialog_ShopAddressInvoice = false, IsReadonly = false, Photo.Photo_link=''"><v-icon color="danger">mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-row row>
              <v-col class="pb-0 pt-2 px-0">
                <v-row row>
                  <v-col cols="12" md="3" class="py-0" >
                    <h4> {{use_language.picture}} : </h4>
                  </v-col>
                  <v-col cols="12" md="9" class="py-0">
                    <a id="pick-avatar" >
                      <v-avatar
                        v-if="Photo.Photo_link!=null && Photo.Photo_link!=''"
                        class="sshoverpicture" size="90" tile >
                        <img :src="Photo.Photo_link"/>
                      </v-avatar>
                      <v-avatar v-else class="sshoverpicture" size="90" tile>
                        {{use_language.no_picture}}
                      </v-avatar>
                    </a>
                    <avatar-cropper
                      @uploading="handleUploading"
                      @uploaded="handleUploaded"
                      @completed="handleCompleted"
                      @error="handlerError"
                      :cropper-options="cropperOptions"
                      :labels="textButton"
                      :upload-url="uploadurl"
                      trigger="#pick-avatar"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                  <h4>  {{use_language.name_person_juristic}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="ShopAddressInvoice.Name"
                      @change="value => ShopAddressInvoice.Name = value"
                      autocomplete="off"
                      ref="refShopAddressInvoiceName"
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4>{{use_language.tax_invoice_number}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="ShopAddressInvoice.IDCardNumber"
                      @change="value => ShopAddressInvoice.IDCardNumber = value"
                      autocomplete="off"
                      ref="refShopAddressInvoiceIDCardNumber"
                      maxlength="13"
                      outlined
                      hide-details
                      @keypress="isNumberWNoDot($event)"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4>{{use_language.tel}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="ShopAddressInvoice.Phone"
                      @change="value => ShopAddressInvoice.Phone = value"
                      autocomplete="off"
                      ref="refShopAddressInvoicePhone"
                      maxlength="10"
                      outlined
                      hide-details
                      @keypress="isNumberWNoDot($event)"
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                  <h4>  {{use_language.address}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="ShopAddressInvoice.TextAddress"
                      @change="value => ShopAddressInvoice.TextAddress = value"
                      autocomplete="off"
                      ref="refShopAddressInvoiceTextAddress"
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4>{{use_language.zipcode}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-autocomplete
                      v-model="ShopAddressInvoice.Address"
                      ref="refShopAddressInvoiceAddress"
                      placeholder="รหัสไปรษณีย์ / จังหวัด / (เขต/อำเภอ) / (แขวง/ตำบล)"
                      :items="postcode_mapping"
                      :item-text="item => item.postcode + ' ' + item.province + ' ' + item.district + ' ' + item.subDistrict"
                      outlined
                      required
                      return-object
                      hide-details
                      dense
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4> {{use_language.set_default}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="1" class="py-0">
                    <v-checkbox
                      :readonly="IsReadonly"
                      v-model="ShopAddressInvoice.IsDefault"
                    ></v-checkbox>
                  </v-col>
                  <v-col  cols="12" md="8">
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="12" align="left" class="py-0">
                    <v-btn v-if="ShopAddressType == 'EDIT'" dark color="primary" @click="AddandEditShopAddressInvoice('EDIT')" class="mr-1"><v-icon left >mdi-content-save</v-icon> {{use_language.record}}</v-btn>
                    <v-btn v-else-if="ShopAddressType == 'ADD'" dark color="primary" @click="AddandEditShopAddressInvoice('ADD')" class="mr-1"><v-icon left >mdi-content-save</v-icon> {{use_language.record}}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_ShopBankAcount" :fullscreen="isFullscreen"  scrollable max-width="50%" persistent >
        <v-card >
          <v-card-title >
            <span v-if="ShopBankAcountType == 'EDIT'" >{{use_language.edit_bank}}</span>
            <span v-else-if="ShopBankAcountType == 'ADD'" >{{use_language.add_bankt}}</span>
            <v-spacer></v-spacer>
            <v-btn icon  @click="dialog_ShopBankAcount = false, IsReadonly = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-divider/>
          <v-card-text>
            <v-row>
              <v-col  cols="12" md="3" class="py-0">
                <h4> {{use_language.bank_name}} :</h4>
              </v-col>
              <v-col cols="12" md="9" class="py-0">
                <v-select
                  ref="BanksID"
                  :items="BankList"
                  v-model="BanksID"
                  item-key="text"
                  item-value="value"
                  dense
                  hide-details
                  outlined
                >
                <template slot="selection" slot-scope="data">
                  <v-avatar v-if="data.item.logo!=null" size="25px" class="mr-2"><img :src="data.item.logo"/></v-avatar>
                  {{ data.item.nameThai }}
                </template>
                <template slot="item" slot-scope="data">
                  <v-avatar v-if="data.item.logo!=null" size="25px" class="mr-2"><img :src="data.item.logo"/></v-avatar>
                  {{ data.item.nameThai }}
                </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4>{{use_language.bank_number}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="AccountNumber"
                      @change="value => AccountNumber = Trim_valueInt(value)"
                      ref="AccountNumber"
                      autocomplete="off"
                      outlined
                      dense hide-details
                      @keypress="isNumberWNoDot($event)"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4>{{use_language.name_account}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="9" class="py-0">
                    <v-text-field
                      :value="AccountName"
                      @change="value => AccountName = value"
                      autocomplete="off"
                      ref="AccountName"
                      maxlength="100"
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4>{{use_language.status}} :</h4>
                  </v-col>
                  <v-col  cols="2" md="1" class="py-0">
                    <v-switch v-model="AccountIsActive" :readonly="IsReadonly" color="success" class="mx-2"></v-switch>
                  </v-col>
                  <v-col  cols="10" md="8" class="py-0">
                    <span v-if="AccountIsActive == 1">{{use_language.enable}}</span>
                    <span v-else>{{use_language.disable}}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row row >
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="3" class="py-0">
                    <h4> {{use_language.set_default}} :</h4>
                  </v-col>
                  <v-col  cols="12" md="1" class="py-0">
                    <v-checkbox
                      :readonly="IsReadonly"
                      v-model="AccountIsDefault"
                    ></v-checkbox>
                  </v-col>
                  <v-col  cols="12" md="8"></v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col  cols="12" md="12" class="pb-0 pt-2 px-0">
                <v-row row >
                  <v-col  cols="12" md="12" align="left" class="py-0">
                    <v-btn dark color="primary" @click="BankAcountActionConfirm()" class="mr-1"><v-icon left >mdi-content-save</v-icon> {{use_language.record}}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_ChannelSource " :fullscreen="isFullscreen"  scrollable max-width="60%" persistent >
         <v-card>
            <v-card-title >
              <span v-if="chanal_actions == 'UPDATE'" >{{use_language.edit_sales_channel}}</span>
              <span v-else-if="chanal_actions == 'ADD'" >{{use_language.add_sales_channel}}</span>
              <v-spacer></v-spacer>
              <v-btn icon  @click="dialog_ChannelSource = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <div>
                <v-row v-if="jaspalShop.includes(ShopID)">
                  <v-col cols="3"   align="left">
                    <h3 class="fn-14"> Store Code :</h3>
                  </v-col>
                  <v-col cols="8"   align="left">
                    <v-text-field
                      :value="storeCode"
                      @change="(value) => (storeCode = Trim_value(value))"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="synnexBranch.includes(BranchID)">
                  <v-col cols="3"   align="left">
                    <h3 class="fn-14"> Invoice Account :</h3>
                  </v-col>
                  <v-col cols="8"   align="left">
                    <v-text-field
                      :value="synnexInvoiceAccount"
                      @change="(value) => (synnexInvoiceAccount = Trim_value(value))"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="synnexBranch.includes(BranchID)">
                  <v-col cols="3"   align="left">
                    <h3 class="fn-14"> Sale code :</h3>
                  </v-col>
                  <v-col cols="8"   align="left">
                    <v-text-field
                      :value="synnexSaleCode"
                      @change="(value) => (synnexSaleCode = Trim_value(value))"
                      autocomplete="off"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row >
                  <v-col cols="3" class="py-1">
                    <h3 class="fn-14"> {{use_language.picture}} : </h3>
                  </v-col>
                  <v-col cols="8" class="py-1">

                    <v-avatar
                      v-if="PhotoLink_pre!=null && input_chanalFileUpload == null"
                      class="sshoverpicture" size="90" tile >
                      <img :src="PhotoLink_pre" />
                    </v-avatar><v-file-input
                      v-model="input_chanalFileUpload"
                      ref="input_chanalFileUpload"
                      :label="use_language.select_image"
                      append-icon="mdi-camera"
                    ></v-file-input>
                  </v-col>
                </v-row>
               
                <v-row class="pt-3">
                  <v-col cols="3" class="py-0 pt-1">
                    <h3 class="fn-14"> {{use_language.channel}} : </h3>
                  </v-col>
                  <v-col cols="8" class="py-0 pt-1">
                    <v-text-field
                      :value="input_chanalName"
                      @change="value => input_chanalName = value"
                      autocomplete="off"
                      ref="input_chanalName"
                      outlined
                      hide-details
                      dense
                    />
                  </v-col>
                </v-row>
            
              </div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn v-if="chanal_actions == 'ADD'" dark color="primary" @click="upload_order_update_data_chanal('ADD')" class="mr-1">
                    <v-icon left >mdi-content-save</v-icon> {{ use_language.save }}
                  </v-btn>
                  <v-btn v-if="chanal_actions == 'UPDATE'" dark color="primary" @click="upload_order_update_data_chanal('UPDATE')" class="mr-1">
                    <v-icon left >mdi-content-save</v-icon> {{ use_language.update }}
                  </v-btn>
                </v-col>
              </v-row>
           
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_ExcelHeader" :fullscreen="isFullscreen" scrollable max-width="60%" persistent >
         <v-card>
            <v-card-title >
              <span>{{use_language.setting_excel_header}}</span>
              <v-spacer></v-spacer>
              <v-btn icon  @click="closeDialogExcelHeader"><v-icon color="danger">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <v-row row >
                <v-col  cols="12" md="12" class="pb-0 py-2 px-0">
                  <v-row row >
                    <v-col cols="12" md="3" lg="3" class="pb-0">
                      <h4>Template Name :</h4>
                    </v-col>
                    <v-col cols="12" md="9" lg="9">
                      <v-text-field
                        :value="templateExcelName"
                        @change="value => templateExcelName = value"
                        autocomplete="off"
                        ref="templateExcelName"
                        outlined
                        hide-details
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <!-- Card ตัวเลือก -->
                <v-col cols="5" class="pr-0">
                  <v-card outlined>
                    <v-card-title>{{use_language.choice}}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="max-height: 400px; overflow-y: auto;">
                      <draggable 
                        v-model="headerChoiceList" 
                        group="people" 
                        @start="drag=true" 
                        @end="drag=false"
                        :disabled="templateExcelDefualt == true"
                      >
                        <div 
                          v-for="element in headerChoiceList" 
                          :key="element.id" 
                          style="padding:8px;border:1px solid #ccc; margin-bottom:4px; cursor: pointer"
                        >
                          {{element.name}}
                        </div>
                      </draggable>
                    </v-card-text>

                  </v-card>
                </v-col>

                <v-col cols="2" class="text-center">
                  <a v-if="templateExcelDefualt == false" @click="rotateHeader" style="cursor: pointer">
                    <v-icon size="22">mdi-swap-horizontal-bold</v-icon>
                  </a>
                </v-col>

                <!-- Card ที่เลือก -->
                <v-col cols="5" class="pl-0">
                  <v-card outlined>
                    <v-card-title>{{use_language.choose}}</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="max-height: 400px; overflow-y: auto;">
                      <draggable 
                        v-model="headerChooseList" 
                        group="people" 
                        @start="drag=true" 
                        @end="drag=false"
                        ref="headerChooseList"
                        :disabled="templateExcelDefualt == true"
                      >
                        <div 
                          v-for="element in headerChooseList" 
                          :key="element.id"
                          ref="headerChooseList"
                          style="padding:8px;border:1px solid #ccc; margin-bottom:4px; cursor: pointer"
                        >
                          {{element.name}}
                        </div>
                      </draggable>
                    </v-card-text>

                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn dark color="primary" class="mr-1" @click="btnSaveHeaderExcel">
                    <v-icon left >mdi-content-save</v-icon> {{ use_language.save }}
                  </v-btn>
                </v-col>
              </v-row>
           
            </v-card-actions>
         </v-card>
      </v-dialog>

    </div>
</template>

<script>
    import Loading from '@/website/components/Loading'
    import axios from 'axios'
    import AvatarCropper from "vue-avatar-cropper";
    import { generalService_dotnet, shopService_dotnet } from '@/website/global'
    import { isNumberWNoDot,Trim_value, Trim_valueInt,get_languages,getPostcodeMapping } from '@/website/global_function'
    import draggable from "vuedraggable";

    export default {
        components: {
            Loading,
            AvatarCropper,
            draggable 
        },

        data: () => ({
          //Alert sound setting
          soundUploading: null,
          alertSound: { errorUrl: '', successUrl: '', warningUrl: '' },
          //Abbreviation setting
          abbreviationList: [],
          updateAbbreviation: {
            id: 0,
            shopID: parseInt(localStorage.getItem("shop_id")),
            quotationPrefix: null,
            invoicePrefix: null,
            receiptPrefix: null,
            deliveryPrefix: null
          },
          dialog_Abbreviation: false,

          stampedList: [],
          updateStamped: {
            shopID: parseInt(localStorage.getItem("shop_id")),
            signature: null,
            inputSignature: null,
            seal: null,
            inputSeal: null,
            isEdit: null
          },
          dialog_Stamped: false,
          fileSignature: null,
          fileSeal: null,

          //
          header_token:{'Content-Type': 'application/json', 'Authorization': 'Bearer '+localStorage.getItem('authorization_token')},
          // แสดงภาพ
          ShowPhoto: false,
          ShowPhotoLink: '',
          jaspalShop:[1888,6264,6265,1572,4869,4560],
          synnexBranch:[727,714],
          BranchID : parseInt(localStorage.getItem("branch_id")),
         use_language: null,
          set_language: null,
          test123: "",
            page_loading: true,
            loading: false,
            // ข้อมูล Shop
            ShopAddress: {
              "ID":null,
              "Name": null,
              "Tel": null,
              "Address": null,
              "AddressCity": null,
              "Email": null,
              "PostcodeMappingID":null,
            },
            // เปิดออเดอร์ อนุญาติให้เปิดออเดอร์ได้สต๊อก=0
            OrderActiveLessthanzero: 0,
            OrderActiveLessthanzeroItem: [{ "label": "ไม่ให้เปิดออเดอร์ถ้าสต๊อกสินค้าไม่เพียงพอ", "value": 0 }, { "label": "เปิดออเดอร์ได้ในกรณีสต๊อกไม่เพียงพอ", "value": 1 }],

            // ที่อยู่จัดส่ง
            ShopAddressManage: {
              "ID":null,
              "Name": null,
              "Phone": null,
              "TextAddress": null,
              "Address": null,
              "PostcodeMappingID":null,
              "IsDefault": true,
            },

            // ออกใบกำกับภาษี
            ShopAddressInvoice: {
              "ID":null,
              "Name": null,
              "Phone": null,
              "IDCardNumber": null,
              "TextAddress": null,
              "Address": null,
              "PostcodeMappingID": null,
              "IsDefault": true,
              "Photo":''
            },

            DataShopAddressManage: [],
            ShopAddressInvoiceData: [],
            ShopBankAcountData: [],

            dialog_ShopAddressManage: false,
            dialog_ShopBankAcount: false,
            dialog_ShopAddressInvoice: false,
            ShopAddressType : null,
            ShopBankAcountType : null,
            AutoInvoiceType: null ,
            BankID: null,
            AddressManageID: null,
            ShopAddressManageMinID : null,
            isFullscreen : false,
            shopDisibled : true,
            IsReadonly : false,
            rulesTel: [],
            BankList: [],
            // this.rulesTel = [v => !!v && v.length >= 9 && v.length <= 10 || 'เบอร์โทรตัวเลข 9-10 ตัว']
            // postcode_mapping: PostcodeMapping,
            postcode_mapping: [],

            // shopBank
            BanksID: null,
            BanksName : null,
            AccountNumber: null,
            AccountName: null,
            AccountIsActive: true,
            AccountIsDefault: true,

            // addordermode
            AddOrderMode: null,
            AddOrderMode_tmp: null,
            addOrderModeDisibled: true,
            storeCode:null,
            synnexInvoiceAccount:null,
            synnexSaleCode:null,

            // addordermode COD
            AddOrderModeCod: null,
            AddOrderModeCod_tmp: null,
            addOrderModeDisibledCod: true,

            // vat
            VatType:null,
            VatTypeDisibled:true,
            ShopID :parseInt(localStorage.getItem("shop_id")),
            // chanelsource
            dialog_ChannelSource: false,
            ChannelSourcenameValid:false,
            ChannelSourcePhotoValid:false,
            ChannelSourcenameValidText:null,
            ChannelSourcePhotoValidText:null,
            Data_ChannelSource:{
              "ID":null,
              "Action":null,
              "ShopID":localStorage.getItem("shop_id"),
              "Name":null,
              "Photo":'',
              "Ischannelsource":'true'
            },
            Datatable_ChannelSource:[],
            // AvatarCropper
            Photo:{
              "Photo_link": null,
              "PhotoLinkUpdate": {
                "file":[],
                "fileSize":0,
                "from_Picture":{},
                "from_path":''
              },
            },
            cropperOptions:{
              background:false,
              viewMode:1,
              aspectRatio: 1,
              autoCropArea: 1,
              movable: false,
              zoomable: false
            },
            uploadurl: generalService_dotnet + "Picture/upload-file-with-bucket",
            message: "ready",


            // manage chanal
            data_list_chanal : [],
            input_chanalFileUpload : null,
            PhotoLink_pre : null,
            input_chanalName : null,
            chanal_actions : null,

            // express
            data_express: [],

            img_chanal_valid: false,

            dialog_ExpressManage: false,
            checkbox1 : true,
            express_data: null,

            //excel header
            dialog_ExcelHeader: false,
            ExcelHeaderList: [],
            templateExcelID: 0,
            templateExcelName: null,
            templateExcelDefualt: false,
            headerChoiceList: [],
            headerChooseList: [],

            excel_order_header : [
              { id: 1, name: "เลขออเดอร์"},
              { id: 2, name: "เวลาที่สร้าง"},
              { id: 3, name: "สถานะ"},
              { id: 4, name: "ขนส่ง"},
              { id: 5, name: "trackingNo"},
              { id: 6, name: "เวลาที่ยืนยันออเดอร์"},
              { id: 7, name: "กำลังแพ็ก"},
              { id: 8, name: "แพ็กเรียบร้อย"},
              { id: 9, name: "เวลาที่ส่งให้ขนส่ง"},
              { id: 10, name: "เวลาที่จัดส่งสำเร็จ"},

              { id: 11, name: "สถานะจัดส่ง"},
              { id: 12, name: "เบอร์ผู้ส่ง"},
              { id: 13, name: "ชื่อผู้ส่ง"},
              { id: 14, name: "ที่อยู่ผู้ส่ง"},
              { id: 15, name: "ตำบลผู้ส่ง"},
              { id: 16, name: "อำเภอผู้ส่ง"},
              { id: 17, name: "จังหวัดผู้ส่ง"},
              { id: 18, name: "รหัสไปรษณีย์ผู้ส่ง"},
              { id: 19, name: "เบอร์ผู้รับ"},
              { id: 20, name: "ชื่อผู้รับ"},

              { id: 21, name: "ที่อยู่ผู้รับ"},
              { id: 22, name: "ตำบลผู้รับ"},
              { id: 23, name: "อำเภอผู้รับ"},
              { id: 24, name: "จังหวัดผู้รับ"},
              { id: 25, name: "รหัสไปรษณีย์ผู้รับ"},
              { id: 26, name: "อีเมลผู้รับ"},
              { id: 27, name: "FBผู้รับ"},
              { id: 28, name: "Lineผู้รับ"},
              { id: 29, name: "ที่อยู่ผู้ส่ง อ้างอิง"},
              { id: 30, name: "ที่อยู่ผู้รับ อ้างอิง"},

              { id: 31, name: "ช่องทางการขาย"},
              { id: 32, name: "ชื่อร้านค้า"},
              { id: 33, name: "ธนาคาร"},
              { id: 34, name: "จำนวนเงินรับโอน"},
              { id: 35, name: "สร้างโดย"},
              { id: 36, name: "พนักงานขาย"},
              { id: 37, name: "จำนวน SKU ทั้งหมด"},
              { id: 38, name: "จำนวนสินค้าทั้งหมด"},
              { id: 39, name: "พัสดุที่"},
              { id: 40, name: "สินค้า"},

              { id: 41, name: "SKU"},
              { id: 42, name: "Barcode"},
              { id: 43, name: "Brand"},
              { id: 44, name: "ลักษณะ1"},
              { id: 45, name: "ลักษณะ2"},
              { id: 46, name: "SerialNo"},
              { id: 47, name: "จำนวน"},
              { id: 48, name: "ราคาขาย"},
              { id: 49, name: "ส่วนลดสินค้า"},
              { id: 50, name: "ประเภท"},

              { id: 51, name: "ยอด COD"},
              { id: 52, name: "ราคาสินค้ารวม"},
              { id: 53, name: "ส่วนลด Seller"},
              { id: 54, name: "ส่วนลด Platform"},
              { id: 55, name: "ส่วนลดออเดอร์"},
              { id: 56, name: "ค่าส่ง"},
              { id: 57, name: "ส่วนลดค่าขนส่งจาก seller"},
              { id: 58, name: "ส่วนลดค่าขนส่งจาก platofrm"},
              { id: 59, name: "Vat"},
              { id: 60, name: "ยอด VAT"},

              { id: 61, name: "รวมทั้งหมด"},
              { id: 62, name: "ค่าขนส่ง"},
              { id: 63, name: "ค่าพื้นที่ห่างไกล"},
              { id: 64, name: "ค่าบริการ COD"},
              { id: 65, name: "ค่ากล่อง"},
              { id: 66, name: "ค่าแพ็ค"},
              { id: 67, name: "ส่วนลด"},
              { id: 68, name: "ค่าบับเบิ้ล"},
              { id: 69, name: "ค่าเชื่อมต่อ"},
              { id: 70, name: "เลขอ้างอิง"},

              { id: 71, name: "เลขที่ใบกำกับภาษี"},
              { id: 72, name: "วันที่ออกใบกำกับภาษี"},
              { id: 73, name: "หมายเหตุ"},
              { id: 74, name: "รายการโอน"},
              { id: 75, name: "ชื่อกล่อง"},
              { id: 76, name: "Order Link"},
              { id: 77, name: "ต้นทุนสินค้า"},
            ],

        }),

        computed: {
          alertSoundRows(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            return [
              { key: 'errorUrl', label: this.use_language.sound_error_label },
              { key: 'successUrl', label: this.use_language.sound_success_label },
              { key: 'warningUrl', label: this.use_language.sound_warning_label },
            ]
          },
          textButton(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return { submit:'', cancel:'' };
            return { submit: this.use_language.submit, cancel: this.use_language.cancel }
          },
          headersAbbreviation(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            return [
              { text: this.use_language.quotation, align: 'center', value: 'quotationPrefix', sortable: false , width: '100px'},
              { text: this.use_language.tax_invoice_sale_order, align: 'center', value: 'invoicePrefix', sortable: false, width: '100px' },
              { text: this.use_language.receipt, align: 'center', value: 'receiptPrefix', sortable: false , width: '100px'},
              { text: this.use_language.menu_delivery_note, align: 'center', value: 'deliveryPrefix', sortable: false , width: '100px'},
              { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false , width: '100px'},
            ]
          },
          headersStamped(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            return [
              { text: this.use_language.signature, align: 'center', value: 'signature', sortable: false , width: '100px'},
              { text: this.use_language.stamp, align: 'center', value: 'seal', sortable: false, width: '100px' },
              { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false , width: '100px'},
            ]
          },
          headers1(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            return [
              { text: this.use_language.delivery_address, align: 'left', value: 'fullAddress', sortable: false },
              { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false , width: '100px'},
              { text: this.use_language.delete, align: 'center', value: 'delete', sortable: false , width: '100px'},
            ]
          },
          headersShopAddressInvoice(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            return [
              { text: this.use_language.picture, align: 'center', value: 'shopLogo', sortable: false, width: '100px'},
              { text: this.use_language.tax_invoice_address, align: 'left', value: 'fullAddress', sortable: false },
              { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false , width: '100px'},
              { text: this.use_language.delete, align: 'center', value: 'delete', sortable: false , width: '100px'},
            ]
          },
          headersBankAcount(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            return [
              { text: this.use_language.bank_account, align: 'left', value: 'FullBankAcount', sortable: false },
              { text: this.use_language.status, align: 'center', value: 'isActive', sortable: false , width: '200px'},
              { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false , width: '100px'},
              { text: this.use_language.delete, align: 'center', value: 'delete', sortable: false , width: '100px'},
            ]
          },
          headerschannelsource(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            var h = [
              { text: this.use_language.picture, align: 'center', value: 'logoPic', sortable: false, width: '100px'},
              { text: this.use_language.channel, align: 'left', value: 'channelName', sortable: false , width: '400px'},
              { text: this.use_language.date, align: 'center', value: 'created', sortable: false, width: '200px' },
              { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false , width: '100px'},
              { text: this.use_language.delete, align: 'center', value: 'delete', sortable: false , width: '100px'},
            ]
            if(this.jaspalShop.includes(this.ShopID)){
              h.splice(3,0,{ text: "Store Code", align: "center", sortable: false, value: "ap21_sale_code", width: "70px" })
            }
            if(this.synnexBranch.includes(this.BranchID)){
              h.splice(3,0,
                { text: "Invoice Account", align: "left", sortable: false, value: "synnex_invoice_account", width: "150px" },
                { text: "Sale code", align: "left", sortable: false, value: "synnex_invent_account", width: "150px" })
            }
            return h
          },
          headersExpress(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            return [
              { text: this.use_language.picture, align: 'center', value: 'logoPic', sortable: false, width: '100px'},
              { text: this.use_language.transport, align: 'left', value: 'expressCompanyName', sortable: false , width: '400px'},
              { text: this.use_language.edit, align: 'center', value: 'action', sortable: false , width: '50px'},
            ]
          },
          headersExcelHeader(){
            if(this.use_language==null||Object.keys(this.use_language).length==0) return [];
            return [
              { text: 'No', align: 'center', value: 'no', sortable: false, width: '50px'},
              { text: 'Template', align: 'left', value: 'templateName', sortable: false , width: '400px'},
              { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false , width: '50px'},
              { text: this.use_language.delete, align: 'center', value: 'delete', sortable: false , width: '50px'},
              { text: this.use_language.copy, align: 'center', value: 'copy', sortable: false , width: '50px'},
            ]
          },
        },

        watch: {
          shopDisibled(){
            if (!this.shopDisibled){
              this.getCreateOrderValue()
            }else{
              this.getCreateOrderLabel()
            }
          },
          async fileSignature() {
            var signature64 = null
            if (this.fileSignature != null) {
              let fileToBase64 = null
              const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
              })
              fileToBase64 = await toBase64(this.fileSignature)
              signature64 = fileToBase64
            }
            this.updateStamped.inputSignature = signature64
          },
          async fileSeal() {
            var seal64 = null
            if (this.fileSeal != null) {
              let fileToBase64 = null
              const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
              })
              fileToBase64 = await toBase64(this.fileSeal)
              seal64 = fileToBase64
            }
            this.updateStamped.inputSeal = seal64
          },
        },

        async created() {
            // document.title = this.$router.history.current.meta.title
            // this.shop_id = localStorage.getItem("shop_id")
            // this.staff_id = localStorage.getItem("staff_id")

          this.postcode_mapping = await this.getPostcodeMapping();
         this.use_language = await this.get_languages(localStorage.getItem("set_language"));
         this.OrderActiveLessthanzeroItem = [{ "label": this.use_language.do_not_open_order_if_stock_insufficient, "value": 0 }, { "label": this.use_language.open_order_if_stock_insufficient, "value": 1 }];


            


            await this.load_data()
            this.loadAlertSound()

            // await this.get_bank_setting()


            // await this.data_shop()

            // await this.get_data_manage_shop_address()

            // await this.getDataShopAddressInvoice()

            // await this.getDataBankAcount()

            // await this.get_shop_channelSource_setting()

            this.page_loading = false

            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var navigateExcel = urlParams.get('to')
            if (navigateExcel == 'excel') {
              this.$nextTick(() => {
                this.$refs.excelHeaderCard.$el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              });
            }
        },

        methods: {
          async loadAlertSound() {
            try {
              let res = await axios.post(shopService_dotnet+'StaffAuthentication/get-alert-sound', { ShopID: parseInt(localStorage.getItem("shop_id")) }, { headers: this.header_token })
              if (res.data && res.data.status) {
                this.alertSound = {
                  errorUrl: res.data.errorUrl || '',
                  successUrl: res.data.successUrl || '',
                  warningUrl: res.data.warningUrl || '',
                }
              }
            } catch (e) { /* ไม่มี config = ใช้ default */ }
          },
          playAlertSound(key) {
            const url = this.alertSound[key]
            if (!url) return
            try { new Audio(url).play() } catch (e) { /* ignore */ }
          },
          triggerSoundUpload(key) {
            const el = this.$refs['soundFile_'+key]
            const input = Array.isArray(el) ? el[0] : el
            if (input) input.click()
          },
          async onSoundFileChange(event, key) {
            const file = event.target.files && event.target.files[0]
            if (!file) return
            this.soundUploading = key
            try {
              const form = new FormData()
              form.append('file', file)
              form.append('bucket', 'sound')
              let res = await axios.post(generalService_dotnet + 'Picture/upload-file-with-bucket', form, { headers: { 'Authorization': this.header_token.Authorization } })
              if (res.data && res.data.file_path) {
                this.$set(this.alertSound, key, res.data.file_path)
              } else {
                this.$swal({ type:'error', title:this.use_language.upload_failed, text:'' })
              }
            } catch (e) {
              this.$swal({ type:'error', title:this.use_language.upload_failed, text:'' })
            } finally {
              this.soundUploading = null
              event.target.value = ''
            }
          },
          async btnSaveAlertSound() {
            try {
              let res = await axios.post(shopService_dotnet+'StaffAuthentication/save-alert-sound', {
                ShopID: parseInt(localStorage.getItem("shop_id")),
                ErrorUrl: this.alertSound.errorUrl,
                SuccessUrl: this.alertSound.successUrl,
                WarningUrl: this.alertSound.warningUrl,
              }, { headers: this.header_token })
              if (res.data && res.data.status) {
                // อัปเดต localStorage ให้มีผลทันที ไม่ต้อง login ใหม่
                localStorage.setItem('alert_error_url', res.data.errorUrl || '')
                localStorage.setItem('alert_success_url', res.data.successUrl || '')
                localStorage.setItem('alert_warning_url', res.data.warningUrl || '')
                this.$swal({ toast:true, position:'top', type:'success', title:this.use_language.alert_sound_saved, timer:2000, showConfirmButton:false })
              }
            } catch (e) {
              this.$swal({ type:'error', title:this.use_language.save_failed, text:'' })
            }
          },
          async getExcelHeaderList() {
            let response = await axios.post(
              shopService_dotnet + 'ShopSetting/get-header-excel-list',
              { 'shopID': parseInt(localStorage.getItem("shop_id")) }, 
              {headers: this.header_token} 
            )
            var findDefault = response.data.filter(i => i.isDefault == true)[0]
            this.ExcelHeaderList = response.data.filter(i => i.isDefault == false)
            this.ExcelHeaderList.unshift(findDefault)
          },
          async openDialogExcelHeader(isNew, item) {
            if (isNew == true) {
              this.templateExcelID = 0
              this.templateExcelName = null
              this.templateExcelDefualt = false
              this.headerChoiceList = this.excel_order_header
            } else {
              var headerIdList = item.headersID.split(",").map(i => parseInt(i))
              this.templateExcelID = item.id
              this.templateExcelName = item.templateName
              this.templateExcelDefualt = item.isDefault
              this.headerChoiceList = this.excel_order_header.filter(item => !headerIdList.includes(item.id));
              this.headerChooseList = headerIdList.map(id => this.excel_order_header.find(item => item.id === id)).filter(Boolean);
            }
            this.dialog_ExcelHeader = true
          },
          async closeDialogExcelHeader() {
            this.templateExcelID = 0
            this.templateExcelName = null
            this.templateExcelDefualt = false
            this.headerChoiceList = []
            this.headerChooseList = []
            this.dialog_ExcelHeader = false
          },
          async rotateHeader() {
            if (this.headerChoiceList.length > 0) {
              this.headerChooseList = this.excel_order_header
              this.headerChoiceList = []
            } else {
              this.headerChoiceList = this.excel_order_header
              this.headerChooseList = []
            }
          },
          async btnSaveHeaderExcel() {
            if(this.templateExcelName == null || this.templateExcelName == '') {
              this.$refs.templateExcelName.focus()
              return
            } else if(this.headerChooseList.length == 0) {
              this.$swal({
                toast: true,
                timer: 3000,
                showConfirmButton: true,
                position: 'top',
                type: 'warning',
                title: this.use_language.please_select_excel_header
              })
              return
            }

            var headerIDRaw = ''
            this.headerChooseList.forEach( e => {
              headerIDRaw = headerIDRaw + e.id.toString() + ","
            });

            let response = await axios.post(
              shopService_dotnet + 'ShopSetting/add-edit-header-excel',
              {
                "id": this.templateExcelID == 1 ? 0 : this.templateExcelID,
                "shopID": parseInt(localStorage.getItem("shop_id")),
                "templateName": this.templateExcelName,
                "headersID": headerIDRaw.slice(0, -1),
                "staffID": parseInt(localStorage.getItem("staff_id")),
                "isDefault": this.templateExcelDefualt
              },
              {headers: this.header_token} 
            )
            if (response.data == "success") {
              this.getExcelHeaderList()
              this.closeDialogExcelHeader()
              this.$swal({
                toast: true,
                timer: 1500,
                showConfirmButton: false,
                position: 'top',
                type: 'success',
                title: this.use_language.save_success
              })
            } else {
              this.$swal({
                showConfirmButton: true,
                position: 'top',
                type: 'error',
                title: response.data
              })
            }
          },
          async btnCopyHeaderExcel(item) {
            this.$swal({
              type: "question",
              title: this.use_language.confirm_copy_question,
              text: this.use_language.want_to_copy_template + " \"" + item.templateName + "\"",
              confirmButtonText: this.use_language.confirm,
              cancelButtonText: this.use_language.cancel,
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              allowOutsideClick: false,
            }).then(async (result) => {
              if (result.value) {
                let response = await axios.post(
                  shopService_dotnet + 'ShopSetting/add-edit-header-excel',
                  {
                    "id": 0,
                    "shopID": parseInt(localStorage.getItem("shop_id")),
                    "templateName": item.templateName + " (copy)",
                    "headersID": item.headersID,
                    "staffID": parseInt(localStorage.getItem("staff_id")),
                    "isDefault": false
                  },
                  {headers: this.header_token} 
                )
                if (response.data == "success") {
                  this.getExcelHeaderList()
                  this.$swal({
                    toast: true,
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'top',
                    type: 'success',
                    title: this.use_language.copied
                  })
                } else {
                  this.$swal({
                    showConfirmButton: true,
                    position: 'top',
                    type: 'error',
                    title: response.data
                  })
                }
              }
            });
          },
          async btnDeleteHeaderExcel(item) {
            this.$swal({
              position: "top",
              type: 'warning',
              title: this.use_language.warning_yes_no,
              confirmButtonText: this.use_language.confirm,
              cancelButtonText: this.use_language.cancel,
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              allowOutsideClick: false
            }).then(async(result) => {
              if (result.value) {
                let response = await axios.post(
                  shopService_dotnet + 'ShopSetting/delete-header-excel',
                  {
                    "id": item.id,
                  },
                  {headers: this.header_token} 
                )
                if (response.data == "success") {
                  this.getExcelHeaderList()
                  this.$swal({
                    toast: true,
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'top',
                    type: 'success',
                    title: this.use_language.delete_done
                  })
                } else {
                  this.$swal({
                    showConfirmButton: true,
                    position: 'top',
                    type: 'error',
                    title: response.data
                  })
                }
              }
            })
          },

          //
          async btnUpdateAbbreviation() {
            let response = await axios.post(
              shopService_dotnet + 'ShopSetting/update-abbreviation-bill',
              this.updateAbbreviation, 
              {headers: this.header_token} 
            )
            if (response.status == 200) {
              this.abbreviationList = []
              this.abbreviationList.push(response.data)
              this.closeDialogAbbeviation()
            }
          },
          openDialogAbbeviation(isEdit, item) {
            this.dialog_Abbreviation = true
            if (isEdit == true) {
              this.updateAbbreviation = item
            }
          },
          closeDialogAbbeviation() {
            this.dialog_Abbreviation = false
            this.updateAbbreviation = {
              id: 0,
              shopID: parseInt(localStorage.getItem("shop_id")),
              quotationPrefix: null,
              invoicePrefix: null,
              receiptPrefix: null,
              deliveryPrefix: null
            }
          },

          async btnUpdateStamped()
          {
            var self = this.updateStamped
            let response = await axios.post(
              shopService_dotnet + 'ShopSetting/update-signature-and-seal',
              {
                "shopID": self.shopID,
                "signature": self.signature,
                "signature64": self.inputSignature,
                "seal": self.seal,
                "seal64": self.inputSeal
              }, 
              {headers: this.header_token} 
            )
            if (response.status == 200) {
              this.stampedList = []
              if (response.data.signature != null || response.data.seal != null) {
                this.stampedList.push(response.data)
              }
              this.closeDialogStamped()
            }
          },
          openDialogStamped(isEdit, item) {
            this.dialog_Stamped = true
            if (isEdit == true) {
              this.updateStamped.shopID = item.shopID
              this.updateStamped.signature = item.signature
              this.updateStamped.seal = item.seal
            }
            this.updateStamped.isEdit = isEdit
          },
          closeDialogStamped() {
            this.dialog_Stamped = false
            this.updateStamped = {
              shopID: parseInt(localStorage.getItem("shop_id")),
              signature: null,
              inputSignature: null,
              seal: null,
              inputSeal: null,
              isEdit: null
            }
          },

          isNumberWNoDot,
          Trim_value,
          Trim_valueInt,
          get_languages,
          getPostcodeMapping,
          async load_data () {

            this.loading = true
            await axios.all([
              axios.post(shopService_dotnet+'ShopSetting/get-shop-setting', {'ShopID': localStorage.getItem("shop_id")}, {headers: this.header_token}),
              axios.post(shopService_dotnet+'ShopSetting/get-banks-setting', {}, {headers: this.header_token} ),
              axios.post(shopService_dotnet+'ShopAddress/get-shop-address-list', {'shopID': localStorage.getItem("shop_id"),'isAscending': true, 'orderBy': 1}, {headers: this.header_token} ),
              axios.post(shopService_dotnet+'ShopAddressInvoice/get-shop-address-invoice-list', {'shopID': localStorage.getItem("shop_id"), 'isAscending': true, 'orderBy': 1}, {headers: this.header_token} ),
              axios.post(shopService_dotnet+'ShopSetting/get-shop-bank-acount-setting', {'shopID': localStorage.getItem("shop_id")}, {headers: this.header_token} ),
              axios.post(shopService_dotnet+'ShopSetting/get-shop-channelSource-setting', {'shopID': localStorage.getItem("shop_id")}, {headers: this.header_token}),
              axios.post(shopService_dotnet+'ShopSetting/get-abbreviation-bill', {'shopID': parseInt(localStorage.getItem("shop_id"))}, {headers: this.header_token}),
              axios.post(shopService_dotnet+'ShopSetting/get-signature-and-seal', {'shopID': parseInt(localStorage.getItem("shop_id"))}, {headers: this.header_token}),

            ]).then(axios.spread((res_Shop, res_Banks, res_ShopAddress, res_ShopAddressInvoice, res_BankAcount, res_chanals, res_Abbreviation, res_Stamped) => {
              // data shop
                  this.ShopAddress.Name = res_Shop.data.name
                  this.ShopAddress.Tel = res_Shop.data.phone
                  this.ShopAddress.Email = res_Shop.data.email
                  this.AutoInvoiceType = res_Shop.data.autoInvoiceType
                  this.OrderActiveLessthanzero = res_Shop.data.isAllowAddOrderWhenStockShopNotAvailable

                  if (res_Abbreviation.data.id != 0) {
                    this.abbreviationList.push(res_Abbreviation.data)
                  }

                  if (res_Stamped.data.signature != null || res_Stamped.data.seal != null) {
                    this.stampedList.push(res_Stamped.data)
                  }

                  this.getCreateOrderLabel()
                  if( res_Shop.data.addOrderMode != null ){
                    this.AddOrderMode = res_Shop.data.addOrderMode
                    this.AddOrderMode = this.AddOrderMode.toString()

                    this.AddOrderMode_tmp = res_Shop.data.addOrderMode
                    this.AddOrderMode_tmp = this.AddOrderMode_tmp.toString()
                  }

                  if( res_Shop.data.addOrderModeForCOD != null ){
                    this.AddOrderModeCod = res_Shop.data.addOrderModeForCOD.toString()
                    this.AddOrderModeCod_tmp = res_Shop.data.addOrderModeForCOD.toString()
                  }

                  if(res_Shop.data.defaultVatType != null){
                    this.VatType = res_Shop.data.defaultVatType
                    this.VatType = this.VatType.toString()
                  }
              // data banks
                  this.BankList = res_Banks.data;

              // Shop Address
                  if( res_ShopAddress.data.length > 0){
                    this.DataShopAddressManage = res_ShopAddress.data
                    this.ShopAddressManageMinID = res_ShopAddress.data[0].id
                  }
              // Shop Address invoice
                  if(res_ShopAddressInvoice.data.length > 0) {
                    this.ShopAddressInvoiceData = res_ShopAddressInvoice.data
                  } else {
                    this.ShopAddressInvoiceData = []
                  }

              // bank Acount
                  if( res_BankAcount.data.length > 0){
                    this.ShopBankAcountData = res_BankAcount.data
                  }
              // chanal
                  this.Datatable_ChannelSource = res_chanals.data


            }));

            await this.getExcelHeaderList()

            this.loading = false

          },

          editExpress(item){
            this.dialog_ExpressManage = true
            this.express_data = item
          },

          async data_shop () {

            this.loading = true
            let response = await axios.post(shopService_dotnet+'ShopSetting/get-shop-setting', {
              'ShopID': localStorage.getItem("shop_id")
            }, {headers: this.header_token} )

            this.ShopAddress.Name = response.data.name
            this.ShopAddress.Tel = response.data.phone
            this.ShopAddress.Email = response.data.email
            this.AutoInvoiceType = response.data.autoInvoiceType
            this.OrderActiveLessthanzero = response.data.isAllowAddOrderWhenStockShopNotAvailable

            await this.getCreateOrderLabel()
            // await this.getCreateOrderValue()
            // addorderMode
            if( response.data.addOrderMode != null ){
              this.AddOrderMode = response.data.addOrderMode
              this.AddOrderMode = this.AddOrderMode.toString()

              this.AddOrderMode_tmp = response.data.addOrderMode
              this.AddOrderMode_tmp = this.AddOrderMode_tmp.toString()
            }

            if( response.data.addOrderModeForCOD != null ){
              this.AddOrderModeCod = response.data.addOrderModeForCOD.toString()
              this.AddOrderModeCod_tmp = response.data.addOrderModeForCOD.toString()
            }

            if(response.data.defaultVatType != null){
              this.VatType = response.data.defaultVatType
              this.VatType = this.VatType.toString()
            }

            this.loading = false

          },

          async get_bank_setting  () {
            let response = await axios.post(shopService_dotnet+'ShopSetting/get-banks-setting', {}, {headers: this.header_token} )
            this.BankList = response.data;
          },

          async get_data_manage_shop_address () {
            this.loading = true
            let response = await axios.post(shopService_dotnet+'ShopAddress/get-shop-address-list', {
              'shopID': localStorage.getItem("shop_id"),
              'isAscending': true,
              'orderBy': 1
            }, {headers: this.header_token} )

            if( response.data.length > 0){
              this.DataShopAddressManage = response.data
              this.ShopAddressManageMinID = response.data[0].id
            }
            this.loading = false
          },

          async get_shop_channelSource_setting () {
            this.loading = true
            let response = await axios.post(shopService_dotnet+'ShopSetting/get-shop-channelSource-setting', {
              'shopID': localStorage.getItem("shop_id")
            }, {headers: this.header_token} )

            this.Datatable_ChannelSource = response.data
            this.loading = false
          },

          getCreateOrderLabel(){
            if (this.OrderActiveLessthanzero==0){ this.OrderActiveLessthanzero = this.OrderActiveLessthanzeroItem[0]['label'] }
            else{ this.OrderActiveLessthanzero = this.OrderActiveLessthanzeroItem[1]['label'] }
          },
          getCreateOrderValue(){
            if (this.OrderActiveLessthanzero==this.OrderActiveLessthanzeroItem[0]['label']){ this.OrderActiveLessthanzero = this.OrderActiveLessthanzeroItem[0]['value'] }
            else{ this.OrderActiveLessthanzero = this.OrderActiveLessthanzeroItem[1]['value'] }
          },

          async UpdateShopAddress () {
            if (this.$refs.updateShopForm.validate()) {
              try {
                let response = await axios.post(shopService_dotnet+'ShopSetting/update-shop-setting', {
                  'id': localStorage.getItem("shop_id"),
                  'name': this.ShopAddress.Name,
                  'phone': null,
                  'email': this.ShopAddress.Email,
                  'balanceLimit': null,
                  'addOrderMode': null,
                  'customerType': null,
                  'isHideAddress': true,
                  'defaultExpressCompanyID': null,
                  'autoInvoiceType': null,
                  'isNeedImportFile': true,
                  'isAllowAddOrderWhenStockBranchNotAvailable': null,
                  'isAllowAddOrderWhenStockShopNotAvailable': this.OrderActiveLessthanzero == 0 ? false : true ,
                  'defaultVatType': null,
                  'serviceRateVatType': null,
                  'referenceCode': 'string',
                  'isVrichUseOwnExpress': null,
                  'token': null,
                  'autoCalculateSpaceDate': null

                }, {headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token')}} )
                this.shopDisibled = true
                await this.data_shop()
              } catch (e) {
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
              }

            }
          },

          async ShopAddressAction (item, type) {
            if (type == 'ADD') {
              this.clearDataAddressManage()
              this.dialog_ShopAddressManage = true
              this.ShopAddressType = type
              this.AddressManageID = null
            } else if (type == 'EDIT') {
              await this.getDataAddressManageID(item)
              this.ShopAddressType = type
              this.AddressManageID = item.id

            } else if (type == 'DELETE') {
              this.ShopAddressType = type
              this.$swal({
                position: "top",
                type: 'warning',
                title: this.use_language.warning_yes_no,
                confirmButtonText: this.use_language.confirm,
                cancelButtonText: this.use_language.cancel,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                allowOutsideClick: false
              }).then(async(result) => {
                if (result.value) {
                  this.ShopAddressType = type
                  this.AddressManageID = item.id
                  this.ShopAddressActionConfirm()
                }
              })
            }
          },

          async ShopAddressActionConfirm () {
            if(this.ShopAddressType == 'ADD'){

              if(this.ShopAddressManage.Name == null || this.ShopAddressManage.Name == ''){
                this.$refs.refShopAddressManageName.focus()
                return
              } else if (this.ShopAddressManage.Phone == null || this.ShopAddressManage.Phone == '') {
                this.$refs.refShopAddressManagePhone.focus()
                return
              } else if (this.ShopAddressManage.TextAddress == null || this.ShopAddressManage.TextAddress == '') {
                this.$refs.refShopAddressManageTextAddress.focus()
                return
              } else if (this.ShopAddressManage.Address == null || this.ShopAddressManage.Address == '') {
                this.$refs.refShopAddressManageAddress.focus()
                return
              }

              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'ShopAddress/update-shop-address', {
                    "id": 0,
                    "shopId": localStorage.getItem("shop_id"),
                    "name": this.ShopAddressManage.Name,
                    "phone": this.ShopAddressManage.Phone,
                    "address": this.ShopAddressManage.TextAddress,
                    "postcodeMappingId": this.ShopAddressManage.Address.id,
                    "tumbon": this.ShopAddressManage.Address.subDistrict,
                    "amphoe": this.ShopAddressManage.Address.district,
                    "province": this.ShopAddressManage.Address.province,
                    "postcode": this.ShopAddressManage.Address.postcode,
                    "isDefault": this.ShopAddressManage.IsDefault,
                    "isDeleted": false,
                    "bestsystemCustomerId": null
                }, {headers: this.header_token} )
                this.$swal({
                  toast: true,
                  timer: 1500,
                  showConfirmButton: false,
                  position: 'top',
                  type: 'success',
                  title: this.use_language.done
                })
                  this.dialog_ShopAddressManage = false
                  this.loading = false
                this.get_data_manage_shop_address()
              } catch (e) {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }


            } else if (this.ShopAddressType == 'EDIT') {
              if(this.ShopAddressManage.Name == null || this.ShopAddressManage.Name == ''){
                this.$refs.refShopAddressManageName.focus()
                return
              } else if (this.ShopAddressManage.Phone == null || this.ShopAddressManage.Phone == '') {
                this.$refs.refShopAddressManagePhone.focus()
                return
              } else if (this.ShopAddressManage.TextAddress == null || this.ShopAddressManage.TextAddress == '') {
                this.$refs.refShopAddressManageTextAddress.focus()
                return
              } else if (this.ShopAddressManage.Address == null || this.ShopAddressManage.Address == '') {
                this.$refs.refShopAddressManageAddress.focus()
                return
              }

              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'ShopAddress/update-shop-address', {
                    "id": this.ShopAddressManage.ID,
                    "shopId": localStorage.getItem("shop_id"),
                    "name": this.ShopAddressManage.Name,
                    "phone": this.ShopAddressManage.Phone,
                    "address": this.ShopAddressManage.TextAddress,
                    "postcodeMappingId": this.ShopAddressManage.Address.id,
                    "tumbon": this.ShopAddressManage.Address.subDistrict,
                    "amphoe": this.ShopAddressManage.Address.district,
                    "province": this.ShopAddressManage.Address.province,
                    "postcode": this.ShopAddressManage.Address.postcode,
                    "isDefault": this.ShopAddressManage.IsDefault,
                    "isDeleted": false,
                    "bestsystemCustomerId": null
                }, {headers: this.header_token} )
                this.$swal({
                  toast: true,
                  timer: 1500,
                  showConfirmButton: false,
                  position: 'top',
                  type: 'success',
                  title: this.use_language.done
                })
                  this.dialog_ShopAddressManage = false
                  this.IsReadonly = false
                  this.loading = false
                  this.get_data_manage_shop_address()
              } catch (e) {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }
            } else if (this.ShopAddressType == 'DELETE' ) {


              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'shopAddress/delete-shop-address', {
                  'id': this.AddressManageID
                }, {headers: this.header_token} )
                this.$swal({
                  toast: true,
                  timer: 1500,
                  showConfirmButton: false,
                  position: 'top',
                  type: 'success',
                  title: this.use_language.delete_done
                })
                this.loading = false
                this.get_data_manage_shop_address()
              } catch (e) {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }
            }

          },

          async getDataAddressManageID (item) {
            // var ShopAddressManage = response.data.resultShopAddress[0]
            this.ShopAddressManage.ID = item.id
            this.ShopAddressManage.Name = item.name
            this.ShopAddressManage.Phone = item.phone
            this.ShopAddressManage.TextAddress = item.address
            this.ShopAddressManage.IsDefault = item.isDefault
            this.ShopAddressManage.Address = {
                "id": item.postcodeMappingId,
                "subDistrict": item['subDistrict'],
                "district": item['district'],
                "province": item['province'],
                "postcode": item['postcode'],
                "provinceId": item['provinceId']
            }

            if(this.ShopAddressManage.IsDefault == true) {
              this.IsReadonly = true
            }

            this.dialog_ShopAddressManage = true

          },

          async getDataShopAddressInvoice () {

            try {
              this.loading = true
              let response = await axios.post(shopService_dotnet+'ShopAddressInvoice/get-shop-address-invoice-list', {
                'shopID': localStorage.getItem("shop_id"),
                'isAscending': true,
                'orderBy': 1
              }, {headers: this.header_token} )

              if(response.data.length > 0) {
                this.ShopAddressInvoiceData = response.data
              } else {
                this.ShopAddressInvoiceData = []
              }

              this.loading = false

            } catch (e) {
              this.$swal({
                type: 'warning',
                title: this.use_language.warning_error_try_again,
              })
              this.loading = false
            }

          },

          addShopAddressInvoice () {
            this.clearDataAddressInvoice()
            this.Data_ChannelSource.Ischannelsource=false
            this.dialog_ShopAddressInvoice = true
          },

          async AddandEditShopAddressInvoice (type) {
            if(this.ShopAddressInvoice.Name == null || this.ShopAddressInvoice.Name == ''){
              this.$refs.refShopAddressInvoiceName.focus()
              return
            } else if (this.ShopAddressInvoice.Phone == null || this.ShopAddressInvoice.Phone == '') {
              this.$refs.refShopAddressInvoicePhone.focus()
              return
            } else if (this.ShopAddressInvoice.TextAddress == null || this.ShopAddressInvoice.TextAddress == '') {
              this.$refs.refShopAddressInvoiceTextAddress.focus()
              return
            } else if (this.ShopAddressInvoice.Address == null || this.ShopAddressInvoice.Address == '') {
              this.$refs.refShopAddressInvoiceAddress.focus()
              return
            }

            if(type == 'ADD'){
              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'ShopAddressInvoice/update-shop-address-invoice', {
                    "id": 0,
                    "shopId": localStorage.getItem("shop_id"),
                    "name": this.ShopAddressInvoice.Name,
                    "idcardNumber": this.ShopAddressInvoice.IDCardNumber,
                    "phone": this.ShopAddressInvoice.Phone,
                    "address": this.ShopAddressInvoice.TextAddress,
                    "postcodeMappingId": this.ShopAddressInvoice.Address.id,
                    "shopLogo": this.ShopAddressInvoice.Photo != "" ? this.ShopAddressInvoice.Photo : null ,
                    "isDefault": this.ShopAddressInvoice.IsDefault,
                    "isDeleted": false,
                }, {headers: this.header_token} )
                this.$swal({
                  toast: true,
                  timer: 1500,
                  showConfirmButton: false,
                  position: 'top',
                  type: 'success',
                  title: this.use_language.done
                })
                  this.dialog_ShopAddressInvoice = false
                  this.loading = false
                this.getDataShopAddressInvoice()
              } catch (e) {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }
            } else if (type == 'EDIT') {
              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'ShopAddressInvoice/update-shop-address-invoice', {
                    "id": this.ShopAddressInvoice.ID,
                    "shopId": localStorage.getItem("shop_id"),
                    "name": this.ShopAddressInvoice.Name,
                    "idcardNumber": this.ShopAddressInvoice.IDCardNumber,
                    "phone": this.ShopAddressInvoice.Phone,
                    "address": this.ShopAddressInvoice.TextAddress,
                    "postcodeMappingId": this.ShopAddressInvoice.Address.id,
                    "shopLogo": this.ShopAddressInvoice.Photo != "" ? this.ShopAddressInvoice.Photo : null ,
                    "isDefault": this.ShopAddressInvoice.IsDefault,
                    "isDeleted": false,
                }, {headers: this.header_token} )
                this.$swal({
                  toast: true,
                  timer: 1500,
                  showConfirmButton: false,
                  position: 'top',
                  type: 'success',
                  title: this.use_language.done
                })
                  this.dialog_ShopAddressInvoice = false
                  this.loading = false
                this.getDataShopAddressInvoice()
              } catch (e) {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }
            }

          },

          deleteShopAddressInvoice (AddressInvoceID) {
            this.$swal({
              position: "top",
              type: 'warning',
              title: this.use_language.warning_yes_no,
              confirmButtonText: this.use_language.confirm,
              cancelButtonText: this.use_language.cancel,
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              allowOutsideClick: false
            }).then(async(result) => {
              if (result.value) {
                this.deleteShopAddressInvoiceConfirm(AddressInvoceID)
              }
            })
          },

          async deleteShopAddressInvoiceConfirm (AddressInvoceID) {

            try {
              this.loading = true
              let response = await axios.post(shopService_dotnet+'ShopAddressInvoice/delete-shop-address-invoice', {
                'id': AddressInvoceID
              }, {headers: this.header_token} )
              this.$swal({
                toast: true,
                timer: 1500,
                showConfirmButton: false,
                position: 'top',
                type: 'success',
                title: this.use_language.delete_done
              })
              this.loading = false
              this.getDataShopAddressInvoice()
            } catch (e) {
              this.$swal({
                type: 'warning',
                title: this.use_language.warning_error_try_again,
              })
              this.loading = false
            }
          },


          async getShopAddressInvoiceForEdit (item) {
            this.ShopAddressInvoice.ID = item.id
            this.ShopAddressInvoice.Name = item.name
            this.ShopAddressInvoice.Phone = item.phone
            this.ShopAddressInvoice.IDCardNumber = item.idCardNumber
            this.ShopAddressInvoice.TextAddress = item.address
            this.ShopAddressInvoice.IsDefault = item.isDeleted
            this.Photo.Photo_link = item.shopLogo
            this.Data_ChannelSource.Ischannelsource = false
            this.ShopAddressInvoice.Address = {
               "id": item.postcodeMappingID,
               "subDistrict": item['subDistrict'],
               "district": item['district'],
               "province": item['province'],
               "postcode": item['postcode'],
               "provinceId": item['provinceID']
            }

            if (this.ShopAddressInvoice.IsDefault == true) {
                this.IsReadonly = true
            }

            this.dialog_ShopAddressInvoice = true

          },

          async BankAcountAction (item, type) {
            if (type == 'ADD') {
              this.clearDataBankAcount()
              this.dialog_ShopBankAcount = true
              this.ShopBankAcountType = type
              this.BankID = null
            } else if (type == 'EDIT') {
              await this.getDataBankAcountID(item)
              this.ShopBankAcountType = type
              this.BankID = item.id

            } else if (type == 'DELETE') {
              this.ShopBankAcountType = type
              this.$swal({
                position: "top",
                type: 'warning',
                title: this.use_language.warning_yes_no,
                confirmButtonText: this.use_language.confirm,
                cancelButtonText: this.use_language.cancel,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                allowOutsideClick: false
              }).then(async(result) => {
                if (result.value) {
                  this.ShopBankAcountType = type
                  this.BankID = item.id
                  this.BankAcountActionConfirm()
                }
              })
            } else if (type == 'DEFAULT') {
              this.$swal({
                position: "top",
                type: 'warning',
                title: this.use_language.warning_set_default,
                confirmButtonText: this.use_language.confirm,
                cancelButtonText: this.use_language.cancel,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                allowOutsideClick: false
              }).then(async(result) => {
                if (result.value) {
                  this.ShopBankAcountType = type
                  this.BankID = item.id
                  this.BankAcountActionConfirm()
                }
              })
            }
          },

          async getDataBankAcount () {


            try {
              this.loading = true
              let response = await axios.post(shopService_dotnet+'ShopSetting/get-shop-bank-acount-setting', {
                'shopID': localStorage.getItem("shop_id")
              }, {headers: this.header_token} )

              if( response.data.length > 0){
                this.ShopBankAcountData = response.data
              }

              this.loading = false
            } catch (e) {
              this.$swal({
                type: 'warning',
                title: this.use_language.warning_error_try_again,
              })
              this.loading = false
            }
          },

          async getDataBankAcountID (item) {

            this.BanksID = item.bankId
            this.BanksName = item.bankName
            this.AccountNumber = item.accountNumber
            this.AccountName =  item.accountName
            this.AccountIsActive = item.isActive
            this.AccountIsDefault = item.isDefault

            if(this.AccountIsDefault == true) {
              this.IsReadonly = true
            }

            this.dialog_ShopBankAcount = true
            this.loading = false

          },

          async BankAcountActionConfirm () {
            if(this.ShopBankAcountType == 'ADD'){
              if(this.BanksID == null ){
                this.$refs.BanksID.focus()
                return
              }else if (this.AccountNumber == null || this.AccountNumber == '') {
                this.$refs.AccountNumber.focus()
                return
              }else if (this.AccountName == null || this.AccountName == '') {
                this.$refs.AccountName.focus()
                return
              }

              var BankListNameThai
              let BankListfiltered = this.BankList.find(x => x.id === this.BanksID)
              BankListNameThai = BankListfiltered['nameThai']


              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'ShopSetting/add-shop-bank-acount-setting', {
                      "Id" : 0,
                      "ShopId" : localStorage.getItem("shop_id"),
                      "BankId" : this.BanksID,
                      "BankName" : BankListNameThai,
                      "AccountNumber" : this.AccountNumber,
                      "AccountName" : this.AccountName,
                      "IsActive" : true,
                      "IsDefault" : this.AccountIsDefault,
                      "IsDeleted" : false
                }, {headers: this.header_token} )

                if(response.data == 'สำเร็จ'){
                  this.$swal({
                    toast: true,
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'top',
                    type: 'success',
                    title: this.use_language.done
                  })
                  this.loading = false
                  this.dialog_ShopBankAcount = false
                  this.getDataBankAcount()
                } else {
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
                  this.loading = false
                }

              } catch (e) {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }

            } else if (this.ShopBankAcountType == 'EDIT') {
              if( this.BanksID == null ){
                this.$refs.BanksID.focus()
                return
              }else if (this.AccountNumber == null || this.AccountNumber == '') {
                this.$refs.AccountNumber.focus()
                return
              }else if (this.AccountName == null || this.AccountName == '') {
                this.$refs.AccountName.focus()
                return
              }

              var BankListNameThaiEdit
              let BankListfiltered = this.BankList.find(x => x.id === this.BanksID)
              BankListNameThaiEdit = BankListfiltered['nameThai']

              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'ShopSetting/add-shop-bank-acount-setting', {
                  "Id" : this.BankID,
                  "ShopId" : localStorage.getItem("shop_id"),
                  "BankId" : this.BanksID,
                  "BankName" : BankListNameThaiEdit,
                  "AccountNumber" : this.AccountNumber,
                  "AccountName" : this.AccountName,
                  "IsActive" : true,
                  "IsDefault" : this.AccountIsDefault,
                  "IsDeleted" : false
                }, {headers: this.header_token} )

                if(response.data == 'สำเร็จ'){
                  this.$swal({
                    toast: true,
                    timer: 1500,
                    showConfirmButton: false,
                    position: 'top',
                    type: 'success',
                    title: this.use_language.done
                  })
                  this.loading = false
                  this.dialog_ShopBankAcount = false
                  this.getDataBankAcount()
                } else {
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
                  this.loading = false
                }


              } catch (e) {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }


            } else if (this.ShopBankAcountType == 'DELETE' ) {
              this.loading = true
              let response = await axios.post(shopService_dotnet+'ShopSetting/delete-shop-bank-acount-setting', {
                "id" : this.BankID,
              }, {headers: this.header_token} )

              if(response.data == 'สำเร็จ'){
                this.$swal({
                  toast: true,
                  timer: 1500,
                  showConfirmButton: false,
                  position: 'top',
                  type: 'success',
                  title: this.use_language.done
                })
                this.loading = false
                this.dialog_ShopBankAcount = false
                this.getDataBankAcount()
              } else {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }
            }
          },

          async UpdateAddOrderModeDisibled () {

            if (this.AddOrderMode == this.AddOrderMode_tmp) {
              this.addOrderModeDisibled = true
              return
            } else {

              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'ShopSetting/update-shop-setting', {
                  'id': localStorage.getItem("shop_id"),
                  'addOrderMode': this.AddOrderMode,
                }, {headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token')}} )

                if(response.data == 'sucsess'){
                  this.shopDisibled = true
                  this.loading = false
                  this.addOrderModeDisibled = true
                  await this.data_shop()
                } else {
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
                  this.loading = false
                }


              } catch (e) {
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
              }
            }
          },

          async UpdateAddOrderModeDisibledCod () {
            if (this.AddOrderModeCod == this.AddOrderModeCod_tmp) {
              this.addOrderModeDisibledCod = true
              return
            } else {
              try {
                this.loading = true
                let response = await axios.post(shopService_dotnet+'ShopSetting/update-shop-setting', {
                  'id': localStorage.getItem("shop_id"),
                  'addOrderModeForCOD': this.AddOrderModeCod,
                }, {headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token')}} )

                if(response.data == 'sucsess'){
                  this.shopDisibled = true
                  this.loading = false
                  this.addOrderModeDisibledCod = true
                  await this.data_shop()
                } else {
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
                  this.loading = false
                }
              } catch (e) {
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
              }
            }
          },

          async UpdateVatType(){
            try {
              this.loading = true
              let response = await axios.post(shopService_dotnet+'ShopSetting/update-shop-setting', {
                'id': localStorage.getItem("shop_id"),
                'defaultVatType': this.VatType,
              }, {headers: {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('token')}} )

              if(response.data == 'sucsess'){
                this.shopDisibled = true
                this.loading = false
                this.VatTypeDisibled = true
                await this.data_shop()
              } else {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
                this.loading = false
              }

            } catch (e) {
                this.$swal({
                  type: 'warning',
                  title: this.use_language.warning_error_try_again,
                })
            }
          },

          //img_chanalsource_avartar
          async ChannelSourceAction(item,Action){
            if(Action == "ADD"){
              this.storeCode=null;
              this.synnexInvoiceAccount=null;
              this.synnexSaleCode=null;
              this.chanal_actions = Action
              this.data_list_chanal = []
              this.input_chanalFileUpload = null
              this.input_chanalName = null
              this.PhotoLink_pre = null
              this.dialog_ChannelSource=true
            }else if(Action == "UPDATE"){
              this.chanal_actions = Action

              this.input_chanalName = item.channelName
              this.PhotoLink_pre = item.logoPic
              this.dialog_ChannelSource=true
              this.storeCode=item.ap21_sale_code;
              this.synnexInvoiceAccount=item.synnex_invoice_account;
              this.synnexSaleCode=item.synnex_invent_account;
              this.data_list_chanal = []
              var chanal_list = {
               "id": item.id,
               "photoLink": null,
               "photoLinkBeforeEditing": item.logoPic,
               "chanalName": null ,
               "shopID" : localStorage.getItem("shop_id"),
               "storeCode" : item.ap21_sale_code,
               "synnex_invoice_account" : item.synnex_invoice_account,
               "synnex_invent_account" : item.synnex_invent_account,
             }
             this.data_list_chanal.push(chanal_list)



            }else if(Action == "DELETE"){
              this.$swal({
                position: "center",
                type: 'warning',
                title: this.use_language.warning_yes_no,
                confirmButtonText: this.use_language.confirm,
                cancelButtonText: this.use_language.cancel,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                allowOutsideClick: false
              }).then(async(result) => {
                if (result.value) {
                  this.chanal_actions = Action
                  this.data_list_chanal = []
                  var chanal_list = {
                   "id": item.id,
                   "photoLink": null,
                   "photoLinkBeforeEditing": null,
                   "chanalName": null ,
                   "shopID" : localStorage.getItem("shop_id")
                 }

                  this.data_list_chanal.push(chanal_list)
                  this.upload_order_update_data_chanal('DELETE')
                }
              })
            }
          },

          // AvatarCropper
          async handleUploading(from_data, xhr) {
            from_data.append("bucket", 'shop/'+localStorage.getItem('shop_id'))
            this.Photo.PhotoLinkUpdate['from_Picture'] = from_data
            this.message = "uploading...";
          },
          async handleUploaded(response, from_data, xhr) {
            await this.DelPicture()
            this.Photo.Photo_link = response.file_path;
            this.Photo.PhotoLinkUpdate['from_path'] = response.file_path;
            if(this.Data_ChannelSource.Ischannelsource == true){
              this.Data_ChannelSource.Photo = response.file_path;
            }else{
              this.ShopAddressInvoice.Photo = response.file_path;
            }
            this.message = "user avatar updated.";
            
          },
          handleCompleted(response, from_data, xhr) {
            this.message = "upload completed.";
          },
          handlerError(message, type, xhr) {
            this.message = "Oops! Something went wrong...";
          },
          async DelPicture(){
            if (this.Photo.Photo_link!='' && this.Photo.Photo_link!=null){
              var pathRemove = this.Photo.Photo_link
            
              let response = await axios.post(generalService_dotnet+'General/delete-file', {'path':pathRemove}, { headers: this.header_token })
              if (response.status ==200){
                this.Photo.Photo_link  = ''
                if(this.Data_ChannelSource.Photo!=''&& this.Data_ChannelSource.Photo!=null){
                  this.Data_ChannelSource.Photo  = ''
                }else if(this.ShopAddressInvoice.Photo!=''&& this.ShopAddressInvoice.Photo!=null){
                  this.ShopAddressInvoice.Photo = ''
                }
              }
            }
          },
          DateNowNotNull() {
            var today = new Date();
            var date = today.getFullYear()+''+((today.getMonth()+1).toString().length> 1 ? (today.getMonth()+1).toString() : '0'+(today.getMonth()+1).toString())+''+(today.getDate().toString().length> 1 ? today.getDate().toString() : '0'+today.getDate().toString());
            var h = today.getHours().toString().length> 1 ? today.getHours().toString() : '0'+today.getHours().toString()
            var m = today.getMinutes().toString().length> 1 ? today.getMinutes().toString() : '0'+today.getMinutes().toString()
            var s = today.getSeconds().toString().length> 1 ? today.getSeconds().toString() : '0'+today.getSeconds().toString()
            var time = h + '' + m + '' + s
            var newDatetime = date+time;
            return newDatetime
          },

          clearDataBankAcount () {
            this.BanksID= null
            this.BanksName = null
            this.AccountNumber= null
            this.AccountName= null
            this.AccountIsActive = true
            this.AccountIsDefault = false
          },

          clearDataAddressManage (){
            this.ShopAddressManage= {
              "ID":null,
              "Name": null,
              "Phone": null,
              "TextAddress": null,
              "Address": null,
              "PostcodeMappingID":null,
              "IsDefault": false,
            }
          },

          clearDataAddressInvoice (){
            this.ShopAddressInvoice= {
              "ID":null,
              "Name": null,
              "Phone": null,
              "IDCardNumber": null,
              "TextAddress": null,
              "Address": null,
              "PostcodeMappingID":null,
              "IsDefault": false,
              "Photo":''
            },
            this.Photo.Photo_link=''
          },
       
          OpenPhoto(Photo){
            this.ShowPhotoLink = Photo
            this.ShowPhoto = true
          },
          Opentap(PhotoLink){
            window.open(PhotoLink);
          },

          async add_data_list_chanal () {
             if (this.input_chanalFileUpload == null) {
                this.$refs.input_chanalFileUpload.focus()
                return
            }else if (this.input_chanalName == null) {
                this.$refs.input_chanalName.focus()
                return
            }


             var fileToBase64 = null
             const toBase64 = file => new Promise((resolve, reject) => {
                 const reader = new FileReader()
                 reader.readAsDataURL(file)
                 reader.onload = () => resolve(reader.result)
                 reader.onerror = error => reject(error)
             })

             if (this.input_chanalFileUpload != null) {
               fileToBase64 = await toBase64(this.input_chanalFileUpload)
             } else {
               fileToBase64 = null
             }

             var data_list_chanal = []
             var chanal_list = {
              "id": this.data_list_chanal.length+1,
              "photoLink": fileToBase64,
              "photoLinkBeforeEditing": null,
              "chanalName": this.input_chanalName ,
              "shopID" : this.ShopID,
              "storeCode":this.storeCode
            }

             this.data_list_chanal.push(chanal_list) 
             
            //
            //  // เคลียข้อมูล
             this.input_chanalFileUpload = null
             this.input_chanalName = null
          },

          delete_data_list_chanal (id) {
            for (var e =0; e < this.data_list_chanal.length; e++){
              if(this.data_list_chanal[e]['id'] == id){
                this.data_list_chanal.splice(e, 1)
                break;
              }
            }
          },

          async upload_order_update_data_chanal (actionss) {

              if(actionss == "UPDATE"){
                    if (this.input_chanalFileUpload != null) {
                      let fileToBase64 = null
                      const toBase64 = file => new Promise((resolve, reject) => {
                          const reader = new FileReader()
                          reader.readAsDataURL(file)
                          reader.onload = () => resolve(reader.result)
                          reader.onerror = error => reject(error)
                      })

                      fileToBase64 = await toBase64(this.input_chanalFileUpload)
                      this.data_list_chanal[0].photoLink = fileToBase64
                    }

                    this.data_list_chanal[0].chanalName = this.input_chanalName
                    this.data_list_chanal[0].storeCode = (this.storeCode==''? null : this.storeCode);
                    this.data_list_chanal[0].synnex_invoice_account = (this.synnexInvoiceAccount==''? null : this.synnexInvoiceAccount);
                    this.data_list_chanal[0].synnex_invent_account = (this.synnexSaleCode==''? null : this.synnexSaleCode);
                    this.loading = true

                    let response = await axios.post(shopService_dotnet+'ShopSetting/add-or-update-shop-channelSource-setting', {
                      "data_chanal_list": this.data_list_chanal,
                      "action": actionss
                    },
                    { headers: this.header_token})
                    if(response.data == 'success'){
                      this.load_data()
                      this.dialog_ChannelSource = false
                    } else {
                      this.$swal({
                        type: 'warning',
                        title: this.use_language.warning_error_try_again,
                      })
                    }

                    this.loading = false


              } else if (actionss == "ADD") {

                if (this.input_chanalFileUpload == null) {
                  this.$refs.input_chanalFileUpload.focus()
                  return
                }else if (this.input_chanalName == null) {
                  this.$refs.input_chanalName.focus()
                  return
                }

                this.loading = true
                let fileToBase64 = null
                const toBase64 = file => new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.readAsDataURL(file)
                    reader.onload = () => resolve(reader.result)
                    reader.onerror = error => reject(error)
                })

                if (this.input_chanalFileUpload != null) {
                  fileToBase64 = await toBase64(this.input_chanalFileUpload)
                } else {
                  fileToBase64 = null
                }

                var data_list_chanal = []
                var chanal_list = {
                  "id": this.data_list_chanal.length+1,
                  "photoLink": fileToBase64,
                  "photoLinkBeforeEditing": null,
                  "chanalName": this.input_chanalName ,
                  "shopID" : this.ShopID,
                  "storeCode":this.storeCode,
                  "synnex_invoice_account": (this.synnexInvoiceAccount==''? null : this.synnexInvoiceAccount),
                  "synnex_invent_account": (this.synnexSaleCode==''? null : this.synnexSaleCode)
                }

                this.data_list_chanal.push(chanal_list) 

                let response = await axios.post(shopService_dotnet+'ShopSetting/add-or-update-shop-channelSource-setting', {
                  "data_chanal_list": this.data_list_chanal,
                  "action": actionss
                },
                { headers: this.header_token})
                if(response.data == 'success'){
                  this.input_chanalFileUpload = null
                  this.input_chanalName = null
                  this.storeCode=null;
                  this.synnexInvoiceAccount=null;
                  this.synnexSaleCode=null;
                  this.load_data()
                  this.dialog_ChannelSource = false
                } else {
                  this.loading = false;
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
                }

                this.loading = false;

              } else if (actionss == "DELETE") {
                let response = await axios.post(shopService_dotnet+'ShopSetting/shop-delete-chanal', {
                  "chanalID": this.data_list_chanal[0].id,
                  "shopID": localStorage.getItem("shop_id")
                },
                { headers: this.header_token})
                if(response.data == 'success'){
                  this.load_data()
                  this.dialog_ChannelSource = false
                } else {
                  this.$swal({
                    type: 'warning',
                    title: this.use_language.warning_error_try_again,
                  })
                }

              }
          },

          async set_default_express (item){

            try {
              let response = await axios.post(shopService_dotnet+'ShopSetting/set-default-shop-express-setting', {
                "expressID": item.id,
                "shopID": localStorage.getItem("shop_id")
              },
              { headers: this.header_token})

              this.dialog_ExpressManage = false
              this.express_data = null
              this.load_data()
            } catch (e) {
              this.$swal({
                type: 'warning',
                title: 'set-default-shop-express-setting มีข้อผิดพลาด !!',
                text: e.message
              })
            }
          },

        }
    }
</script>
<style scoped>
  >>>.vue-avatar-cropper-demo {
    max-width: 18em;
    margin: 0 auto;
  }
  >>>.avatar {
    width: 160px;
    border-radius: 6px;
    display: block;
    margin: 20px auto;
  }
</style>
